"use strict";

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {
    /*!
    * modernizr.min.js
    */
    /*! modernizr 3.3.1 (Custom Build) | MIT *
    * https://modernizr.com/download/?-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
    !function (e, t, n) {
        function i(e, t) {
            return (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) === t;
        }function o() {
            var e, t, n, o, r, s, a;for (var l in w) {
                if (w.hasOwnProperty(l)) {
                    if (e = [], t = w[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) {
                        e.push(t.options.aliases[n].toLowerCase());
                    }for (o = i(t.fn, "function") ? t.fn() : t.fn, r = 0; r < e.length; r++) {
                        s = e[r], a = s.split("."), 1 === a.length ? x[a[0]] = o : (!x[a[0]] || x[a[0]] instanceof Boolean || (x[a[0]] = new Boolean(x[a[0]])), x[a[0]][a[1]] = o), y.push((o ? "" : "no-") + a.join("-"));
                    }
                }
            }
        }function r(e) {
            var t = T.className,
                n = x._config.classPrefix || "";if (C && (t = t.baseVal), x._config.enableJSClass) {
                var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");t = t.replace(i, "$1" + n + "js$2");
            }x._config.enableClasses && (t += " " + n + e.join(" " + n), C ? T.className.baseVal = t : T.className = t);
        }function s() {
            return "function" != typeof t.createElement ? t.createElement(arguments[0]) : C ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
        }function a(e, t) {
            return !!~("" + e).indexOf(t);
        }function l(e) {
            return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {
                return t + n.toUpperCase();
            }).replace(/^-/, "");
        }function c() {
            var e = t.body;return e || (e = s(C ? "svg" : "body"), e.fake = !0), e;
        }function d(e, n, i, o) {
            var r,
                a,
                l,
                d,
                u = "modernizr",
                p = s("div"),
                f = c();if (parseInt(i, 10)) for (; i--;) {
                l = s("div"), l.id = o ? o[i] : u + (i + 1), p.appendChild(l);
            }return r = s("style"), r.type = "text/css", r.id = "s" + u, (f.fake ? f : p).appendChild(r), f.appendChild(p), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(t.createTextNode(e)), p.id = u, f.fake && (f.style.background = "", f.style.overflow = "hidden", d = T.style.overflow, T.style.overflow = "hidden", T.appendChild(f)), a = n(p, e), f.fake ? (f.parentNode.removeChild(f), T.style.overflow = d, T.offsetHeight) : p.parentNode.removeChild(p), !!a;
        }function u(e, t) {
            return function () {
                return e.apply(t, arguments);
            };
        }function p(e, t, n) {
            var o;for (var r in e) {
                if (e[r] in t) return n === !1 ? e[r] : (o = t[e[r]], i(o, "function") ? u(o, n || t) : o);
            }return !1;
        }function f(e) {
            return e.replace(/([A-Z])/g, function (e, t) {
                return "-" + t.toLowerCase();
            }).replace(/^ms-/, "-ms-");
        }function h(t, i) {
            var o = t.length;if ("CSS" in e && "supports" in e.CSS) {
                for (; o--;) {
                    if (e.CSS.supports(f(t[o]), i)) return !0;
                }return !1;
            }if ("CSSSupportsRule" in e) {
                for (var r = []; o--;) {
                    r.push("(" + f(t[o]) + ":" + i + ")");
                }return r = r.join(" or "), d("@supports (" + r + ") { #modernizr { position: absolute; } }", function (e) {
                    return "absolute" == getComputedStyle(e, null).position;
                });
            }return n;
        }function g(e, t, o, r) {
            function c() {
                u && (delete O.style, delete O.modElem);
            }if (r = !i(r, "undefined") && r, !i(o, "undefined")) {
                var d = h(e, o);if (!i(d, "undefined")) return d;
            }for (var u, p, f, g, v, m = ["modernizr", "tspan", "samp"]; !O.style && m.length;) {
                u = !0, O.modElem = s(m.shift()), O.style = O.modElem.style;
            }for (f = e.length, p = 0; f > p; p++) {
                if (g = e[p], v = O.style[g], a(g, "-") && (g = l(g)), O.style[g] !== n) {
                    if (r || i(o, "undefined")) return c(), "pfx" != t || g;try {
                        O.style[g] = o;
                    } catch (e) {}if (O.style[g] != v) return c(), "pfx" != t || g;
                }
            }return c(), !1;
        }function v(e, t, n, o, r) {
            var s = e.charAt(0).toUpperCase() + e.slice(1),
                a = (e + " " + j.join(s + " ") + s).split(" ");return i(t, "string") || i(t, "undefined") ? g(a, t, o, r) : (a = (e + " " + $.join(s + " ") + s).split(" "), p(a, t, n));
        }function m(e, t, i) {
            return v(e, n, n, t, i);
        }var y = [],
            w = [],
            b = { _version: "3.3.1", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {
                var n = this;setTimeout(function () {
                    t(n[e]);
                }, 0);
            }, addTest: function addTest(e, t, n) {
                w.push({ name: e, fn: t, options: n });
            }, addAsyncTest: function addAsyncTest(e) {
                w.push({ name: null, fn: e });
            } },
            x = function x() {};x.prototype = b, x = new x(), x.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);var k = b._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];b._prefixes = k;var T = t.documentElement,
            C = "svg" === T.nodeName.toLowerCase(),
            S = "Moz O ms Webkit",
            $ = b._config.usePrefixes ? S.toLowerCase().split(" ") : [];b._domPrefixes = $;var E = "CSS" in e && "supports" in e.CSS,
            A = "supportsCSS" in e;x.addTest("supports", E || A), x.addTest("placeholder", "placeholder" in s("input") && "placeholder" in s("textarea"));var j = b._config.usePrefixes ? S.split(" ") : [];b._cssomPrefixes = j;var N = b.testStyles = d;x.addTest("touchevents", function () {
            var n;if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;else {
                var i = ["@media (", k.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");N(i, function (e) {
                    n = 9 === e.offsetTop;
                });
            }return n;
        });var D = { elem: s("modernizr") };x._q.push(function () {
            delete D.elem;
        });var O = { style: D.elem.style };x._q.unshift(function () {
            delete O.style;
        }), b.testProp = function (e, t, i) {
            return g([e], n, t, i);
        }, b.testAllProps = v, b.testAllProps = m, x.addTest("csstransforms", function () {
            return -1 === navigator.userAgent.indexOf("Android 2.") && m("transform", "scale(1)", !0);
        }), x.addTest("csstransforms3d", function () {
            var e = !!m("perspective", "1px", !0),
                t = x._config.usePrefixes;if (e && (!t || "webkitPerspective" in T.style)) {
                var n,
                    i = "#modernizr{width:0;height:0}";x.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)", t && (n += ",(-webkit-transform-3d)")), n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", N(i + n, function (t) {
                    e = 7 === t.offsetWidth && 18 === t.offsetHeight;
                });
            }return e;
        }), x.addTest("flexbox", m("flexBasis", "1px", !0)), o(), r(y), delete b.addTest, delete b.addAsyncTest;for (var H = 0; H < x._q.length; H++) {
            x._q[H]();
        }e.Modernizr = x;
    }(window, document), /*!
                         * jquery-2.2.3.min.js
                         */
    /*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
    !function (e, t) {
        "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) && "object" == (0, _typeof3.default)(module.exports) ? module.exports = e.document ? t(e, !0) : function (e) {
            if (!e.document) throw new Error("jQuery requires a window with a document");return t(e);
        } : t(e);
    }("undefined" != typeof window ? window : this, function (e, t) {
        function n(e) {
            var t = !!e && "length" in e && e.length,
                n = re.type(e);return "function" !== n && !re.isWindow(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
        }function i(e, t, n) {
            if (re.isFunction(t)) return re.grep(e, function (e, i) {
                return !!t.call(e, i, e) !== n;
            });if (t.nodeType) return re.grep(e, function (e) {
                return e === t !== n;
            });if ("string" == typeof t) {
                if (ge.test(t)) return re.filter(t, e, n);t = re.filter(t, e);
            }return re.grep(e, function (e) {
                return Z.call(t, e) > -1 !== n;
            });
        }function o(e, t) {
            for (; (e = e[t]) && 1 !== e.nodeType;) {}return e;
        }function r(e) {
            var t = {};return re.each(e.match(xe) || [], function (e, n) {
                t[n] = !0;
            }), t;
        }function s() {
            G.removeEventListener("DOMContentLoaded", s), e.removeEventListener("load", s), re.ready();
        }function a() {
            this.expando = re.expando + a.uid++;
        }function l(e, t, n) {
            var i;if (void 0 === n && 1 === e.nodeType) if (i = "data-" + t.replace(Ae, "-$&").toLowerCase(), n = e.getAttribute(i), "string" == typeof n) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : Ee.test(n) ? re.parseJSON(n) : n);
                } catch (e) {}$e.set(e, t, n);
            } else n = void 0;return n;
        }function c(e, t, n, i) {
            var o,
                r = 1,
                s = 20,
                a = i ? function () {
                return i.cur();
            } : function () {
                return re.css(e, t, "");
            },
                l = a(),
                c = n && n[3] || (re.cssNumber[t] ? "" : "px"),
                d = (re.cssNumber[t] || "px" !== c && +l) && Ne.exec(re.css(e, t));if (d && d[3] !== c) {
                c = c || d[3], n = n || [], d = +l || 1;do {
                    r = r || ".5", d /= r, re.style(e, t, d + c);
                } while (r !== (r = a() / l) && 1 !== r && --s);
            }return n && (d = +d || +l || 0, o = n[1] ? d + (n[1] + 1) * n[2] : +n[2], i && (i.unit = c, i.start = d, i.end = o)), o;
        }function d(e, t) {
            var n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [];return void 0 === t || t && re.nodeName(e, t) ? re.merge([e], n) : n;
        }function u(e, t) {
            for (var n = 0, i = e.length; i > n; n++) {
                Se.set(e[n], "globalEval", !t || Se.get(t[n], "globalEval"));
            }
        }function p(e, t, n, i, o) {
            for (var r, s, a, l, c, p, f = t.createDocumentFragment(), h = [], g = 0, v = e.length; v > g; g++) {
                if (r = e[g], r || 0 === r) if ("object" === re.type(r)) re.merge(h, r.nodeType ? [r] : r);else if (Ie.test(r)) {
                    for (s = s || f.appendChild(t.createElement("div")), a = (Pe.exec(r) || ["", ""])[1].toLowerCase(), l = qe[a] || qe._default, s.innerHTML = l[1] + re.htmlPrefilter(r) + l[2], p = l[0]; p--;) {
                        s = s.lastChild;
                    }re.merge(h, s.childNodes), s = f.firstChild, s.textContent = "";
                } else h.push(t.createTextNode(r));
            }for (f.textContent = "", g = 0; r = h[g++];) {
                if (i && re.inArray(r, i) > -1) o && o.push(r);else if (c = re.contains(r.ownerDocument, r), s = d(f.appendChild(r), "script"), c && u(s), n) for (p = 0; r = s[p++];) {
                    Le.test(r.type || "") && n.push(r);
                }
            }return f;
        }function f() {
            return !0;
        }function h() {
            return !1;
        }function g() {
            try {
                return G.activeElement;
            } catch (e) {}
        }function v(e, t, n, i, o, r) {
            var s, a;if ("object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t))) {
                "string" != typeof n && (i = i || n, n = void 0);for (a in t) {
                    v(e, a, n, i, t[a], r);
                }return e;
            }if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), o === !1) o = h;else if (!o) return e;return 1 === r && (s = o, o = function o(e) {
                return re().off(e), s.apply(this, arguments);
            }, o.guid = s.guid || (s.guid = re.guid++)), e.each(function () {
                re.event.add(this, t, o, i, n);
            });
        }function m(e, t) {
            return re.nodeName(e, "table") && re.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
        }function y(e) {
            return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
        }function w(e) {
            var t = Be.exec(e.type);return t ? e.type = t[1] : e.removeAttribute("type"), e;
        }function b(e, t) {
            var n, i, o, r, s, a, l, c;if (1 === t.nodeType) {
                if (Se.hasData(e) && (r = Se.access(e), s = Se.set(t, r), c = r.events)) {
                    delete s.handle, s.events = {};for (o in c) {
                        for (n = 0, i = c[o].length; i > n; n++) {
                            re.event.add(t, o, c[o][n]);
                        }
                    }
                }$e.hasData(e) && (a = $e.access(e), l = re.extend({}, a), $e.set(t, l));
            }
        }function x(e, t) {
            var n = t.nodeName.toLowerCase();"input" === n && He.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
        }function k(e, t, n, i) {
            t = J.apply([], t);var o,
                r,
                s,
                a,
                l,
                c,
                u = 0,
                f = e.length,
                h = f - 1,
                g = t[0],
                v = re.isFunction(g);if (v || f > 1 && "string" == typeof g && !ie.checkClone && We.test(g)) return e.each(function (o) {
                var r = e.eq(o);v && (t[0] = g.call(this, o, r.html())), k(r, t, n, i);
            });if (f && (o = p(t, e[0].ownerDocument, !1, e, i), r = o.firstChild, 1 === o.childNodes.length && (o = r), r || i)) {
                for (s = re.map(d(o, "script"), y), a = s.length; f > u; u++) {
                    l = o, u !== h && (l = re.clone(l, !0, !0), a && re.merge(s, d(l, "script"))), n.call(e[u], l, u);
                }if (a) for (c = s[s.length - 1].ownerDocument, re.map(s, w), u = 0; a > u; u++) {
                    l = s[u], Le.test(l.type || "") && !Se.access(l, "globalEval") && re.contains(c, l) && (l.src ? re._evalUrl && re._evalUrl(l.src) : re.globalEval(l.textContent.replace(Ue, "")));
                }
            }return e;
        }function T(e, t, n) {
            for (var i, o = t ? re.filter(t, e) : e, r = 0; null != (i = o[r]); r++) {
                n || 1 !== i.nodeType || re.cleanData(d(i)), i.parentNode && (n && re.contains(i.ownerDocument, i) && u(d(i, "script")), i.parentNode.removeChild(i));
            }return e;
        }function C(e, t) {
            var n = re(t.createElement(e)).appendTo(t.body),
                i = re.css(n[0], "display");return n.detach(), i;
        }function S(e) {
            var t = G,
                n = Ye[e];return n || (n = C(e, t), "none" !== n && n || (Xe = (Xe || re("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), t = Xe[0].contentDocument, t.write(), t.close(), n = C(e, t), Xe.detach()), Ye[e] = n), n;
        }function $(e, t, n) {
            var i,
                o,
                r,
                s,
                a = e.style;return n = n || Qe(e), s = n ? n.getPropertyValue(t) || n[t] : void 0, "" !== s && void 0 !== s || re.contains(e.ownerDocument, e) || (s = re.style(e, t)), n && !ie.pixelMarginRight() && Ge.test(s) && Ve.test(t) && (i = a.width, o = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = o, a.maxWidth = r), void 0 !== s ? s + "" : s;
        }function E(e, t) {
            return { get: function get() {
                    return e() ? void delete this.get : (this.get = t).apply(this, arguments);
                } };
        }function A(e) {
            if (e in it) return e;for (var t = e[0].toUpperCase() + e.slice(1), n = nt.length; n--;) {
                if (e = nt[n] + t, e in it) return e;
            }
        }function j(e, t, n) {
            var i = Ne.exec(t);return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
        }function N(e, t, n, i, o) {
            for (var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, s = 0; 4 > r; r += 2) {
                "margin" === n && (s += re.css(e, n + De[r], !0, o)), i ? ("content" === n && (s -= re.css(e, "padding" + De[r], !0, o)), "margin" !== n && (s -= re.css(e, "border" + De[r] + "Width", !0, o))) : (s += re.css(e, "padding" + De[r], !0, o), "padding" !== n && (s += re.css(e, "border" + De[r] + "Width", !0, o)));
            }return s;
        }function D(t, n, i) {
            var o = !0,
                r = "width" === n ? t.offsetWidth : t.offsetHeight,
                s = Qe(t),
                a = "border-box" === re.css(t, "boxSizing", !1, s);if (G.msFullscreenElement && e.top !== e && t.getClientRects().length && (r = Math.round(100 * t.getBoundingClientRect()[n])), 0 >= r || null == r) {
                if (r = $(t, n, s), (0 > r || null == r) && (r = t.style[n]), Ge.test(r)) return r;o = a && (ie.boxSizingReliable() || r === t.style[n]), r = parseFloat(r) || 0;
            }return r + N(t, n, i || (a ? "border" : "content"), o, s) + "px";
        }function O(e, t) {
            for (var n, i, o, r = [], s = 0, a = e.length; a > s; s++) {
                i = e[s], i.style && (r[s] = Se.get(i, "olddisplay"), n = i.style.display, t ? (r[s] || "none" !== n || (i.style.display = ""), "" === i.style.display && Oe(i) && (r[s] = Se.access(i, "olddisplay", S(i.nodeName)))) : (o = Oe(i), "none" === n && o || Se.set(i, "olddisplay", o ? n : re.css(i, "display"))));
            }for (s = 0; a > s; s++) {
                i = e[s], i.style && (t && "none" !== i.style.display && "" !== i.style.display || (i.style.display = t ? r[s] || "" : "none"));
            }return e;
        }function H(e, t, n, i, o) {
            return new H.prototype.init(e, t, n, i, o);
        }function P() {
            return e.setTimeout(function () {
                ot = void 0;
            }), ot = re.now();
        }function L(e, t) {
            var n,
                i = 0,
                o = { height: e };for (t = t ? 1 : 0; 4 > i; i += 2 - t) {
                n = De[i], o["margin" + n] = o["padding" + n] = e;
            }return t && (o.opacity = o.width = e), o;
        }function q(e, t, n) {
            for (var i, o = (z.tweeners[t] || []).concat(z.tweeners["*"]), r = 0, s = o.length; s > r; r++) {
                if (i = o[r].call(n, t, e)) return i;
            }
        }function I(e, t, n) {
            var i,
                o,
                r,
                s,
                a,
                l,
                c,
                d,
                u = this,
                p = {},
                f = e.style,
                h = e.nodeType && Oe(e),
                g = Se.get(e, "fxshow");n.queue || (a = re._queueHooks(e, "fx"), null == a.unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function () {
                a.unqueued || l();
            }), a.unqueued++, u.always(function () {
                u.always(function () {
                    a.unqueued--, re.queue(e, "fx").length || a.empty.fire();
                });
            })), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [f.overflow, f.overflowX, f.overflowY], c = re.css(e, "display"), d = "none" === c ? Se.get(e, "olddisplay") || S(e.nodeName) : c, "inline" === d && "none" === re.css(e, "float") && (f.display = "inline-block")), n.overflow && (f.overflow = "hidden", u.always(function () {
                f.overflow = n.overflow[0], f.overflowX = n.overflow[1], f.overflowY = n.overflow[2];
            }));for (i in t) {
                if (o = t[i], st.exec(o)) {
                    if (delete t[i], r = r || "toggle" === o, o === (h ? "hide" : "show")) {
                        if ("show" !== o || !g || void 0 === g[i]) continue;h = !0;
                    }p[i] = g && g[i] || re.style(e, i);
                } else c = void 0;
            }if (re.isEmptyObject(p)) "inline" === ("none" === c ? S(e.nodeName) : c) && (f.display = c);else {
                g ? "hidden" in g && (h = g.hidden) : g = Se.access(e, "fxshow", {}), r && (g.hidden = !h), h ? re(e).show() : u.done(function () {
                    re(e).hide();
                }), u.done(function () {
                    var t;Se.remove(e, "fxshow");for (t in p) {
                        re.style(e, t, p[t]);
                    }
                });for (i in p) {
                    s = q(h ? g[i] : 0, i, u), i in g || (g[i] = s.start, h && (s.end = s.start, s.start = "width" === i || "height" === i ? 1 : 0));
                }
            }
        }function M(e, t) {
            var n, i, o, r, s;for (n in e) {
                if (i = re.camelCase(n), o = t[i], r = e[n], re.isArray(r) && (o = r[1], r = e[n] = r[0]), n !== i && (e[i] = r, delete e[n]), s = re.cssHooks[i], s && "expand" in s) {
                    r = s.expand(r), delete e[i];for (n in r) {
                        n in e || (e[n] = r[n], t[n] = o);
                    }
                } else t[i] = o;
            }
        }function z(e, t, n) {
            var i,
                o,
                r = 0,
                s = z.prefilters.length,
                a = re.Deferred().always(function () {
                delete l.elem;
            }),
                l = function l() {
                if (o) return !1;for (var t = ot || P(), n = Math.max(0, c.startTime + c.duration - t), i = n / c.duration || 0, r = 1 - i, s = 0, l = c.tweens.length; l > s; s++) {
                    c.tweens[s].run(r);
                }return a.notifyWith(e, [c, r, n]), 1 > r && l ? n : (a.resolveWith(e, [c]), !1);
            },
                c = a.promise({ elem: e, props: re.extend({}, t), opts: re.extend(!0, { specialEasing: {}, easing: re.easing._default }, n), originalProperties: t, originalOptions: n, startTime: ot || P(), duration: n.duration, tweens: [], createTween: function createTween(t, n) {
                    var i = re.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);return c.tweens.push(i), i;
                }, stop: function stop(t) {
                    var n = 0,
                        i = t ? c.tweens.length : 0;if (o) return this;for (o = !0; i > n; n++) {
                        c.tweens[n].run(1);
                    }return t ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]), this;
                } }),
                d = c.props;for (M(d, c.opts.specialEasing); s > r; r++) {
                if (i = z.prefilters[r].call(c, e, d, c.opts)) return re.isFunction(i.stop) && (re._queueHooks(c.elem, c.opts.queue).stop = re.proxy(i.stop, i)), i;
            }return re.map(d, q, c), re.isFunction(c.opts.start) && c.opts.start.call(e, c), re.fx.timer(re.extend(l, { elem: e, anim: c, queue: c.opts.queue })), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always);
        }function _(e) {
            return e.getAttribute && e.getAttribute("class") || "";
        }function F(e) {
            return function (t, n) {
                "string" != typeof t && (n = t, t = "*");var i,
                    o = 0,
                    r = t.toLowerCase().match(xe) || [];if (re.isFunction(n)) for (; i = r[o++];) {
                    "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
                }
            };
        }function R(e, t, n, i) {
            function o(a) {
                var l;return r[a] = !0, re.each(e[a] || [], function (e, a) {
                    var c = a(t, n, i);return "string" != typeof c || s || r[c] ? s ? !(l = c) : void 0 : (t.dataTypes.unshift(c), o(c), !1);
                }), l;
            }var r = {},
                s = e === $t;return o(t.dataTypes[0]) || !r["*"] && o("*");
        }function W(e, t) {
            var n,
                i,
                o = re.ajaxSettings.flatOptions || {};for (n in t) {
                void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
            }return i && re.extend(!0, e, i), e;
        }function B(e, t, n) {
            for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0];) {
                l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
            }if (i) for (o in a) {
                if (a[o] && a[o].test(i)) {
                    l.unshift(o);break;
                }
            }if (l[0] in n) r = l[0];else {
                for (o in n) {
                    if (!l[0] || e.converters[o + " " + l[0]]) {
                        r = o;break;
                    }s || (s = o);
                }r = r || s;
            }return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0;
        }function U(e, t, n, i) {
            var o,
                r,
                s,
                a,
                l,
                c = {},
                d = e.dataTypes.slice();if (d[1]) for (s in e.converters) {
                c[s.toLowerCase()] = e.converters[s];
            }for (r = d.shift(); r;) {
                if (e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = d.shift()) if ("*" === r) r = l;else if ("*" !== l && l !== r) {
                    if (s = c[l + " " + r] || c["* " + r], !s) for (o in c) {
                        if (a = o.split(" "), a[1] === r && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                            s === !0 ? s = c[o] : c[o] !== !0 && (r = a[0], d.unshift(a[1]));break;
                        }
                    }if (s !== !0) if (s && e.throws) t = s(t);else try {
                        t = s(t);
                    } catch (e) {
                        return { state: "parsererror", error: s ? e : "No conversion from " + l + " to " + r };
                    }
                }
            }return { state: "success", data: t };
        }function X(e, t, n, i) {
            var o;if (re.isArray(t)) re.each(t, function (t, o) {
                n || Nt.test(e) ? i(e, o) : X(e + "[" + ("object" == (typeof o === "undefined" ? "undefined" : (0, _typeof3.default)(o)) && null != o ? t : "") + "]", o, n, i);
            });else if (n || "object" !== re.type(t)) i(e, t);else for (o in t) {
                X(e + "[" + o + "]", t[o], n, i);
            }
        }function Y(e) {
            return re.isWindow(e) ? e : 9 === e.nodeType && e.defaultView;
        }var V = [],
            G = e.document,
            Q = V.slice,
            J = V.concat,
            K = V.push,
            Z = V.indexOf,
            ee = {},
            te = ee.toString,
            ne = ee.hasOwnProperty,
            ie = {},
            oe = "2.2.3",
            re = function re(e, t) {
            return new re.fn.init(e, t);
        },
            se = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
            ae = /^-ms-/,
            le = /-([\da-z])/gi,
            ce = function ce(e, t) {
            return t.toUpperCase();
        };re.fn = re.prototype = { jquery: oe, constructor: re, selector: "", length: 0, toArray: function toArray() {
                return Q.call(this);
            }, get: function get(e) {
                return null != e ? 0 > e ? this[e + this.length] : this[e] : Q.call(this);
            }, pushStack: function pushStack(e) {
                var t = re.merge(this.constructor(), e);return t.prevObject = this, t.context = this.context, t;
            }, each: function each(e) {
                return re.each(this, e);
            }, map: function map(e) {
                return this.pushStack(re.map(this, function (t, n) {
                    return e.call(t, n, t);
                }));
            }, slice: function slice() {
                return this.pushStack(Q.apply(this, arguments));
            }, first: function first() {
                return this.eq(0);
            }, last: function last() {
                return this.eq(-1);
            }, eq: function eq(e) {
                var t = this.length,
                    n = +e + (0 > e ? t : 0);return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
            }, end: function end() {
                return this.prevObject || this.constructor();
            }, push: K, sort: V.sort, splice: V.splice }, re.extend = re.fn.extend = function () {
            var e,
                t,
                n,
                i,
                o,
                r,
                s = arguments[0] || {},
                a = 1,
                l = arguments.length,
                c = !1;for ("boolean" == typeof s && (c = s, s = arguments[a] || {}, a++), "object" == (typeof s === "undefined" ? "undefined" : (0, _typeof3.default)(s)) || re.isFunction(s) || (s = {}), a === l && (s = this, a--); l > a; a++) {
                if (null != (e = arguments[a])) for (t in e) {
                    n = s[t], i = e[t], s !== i && (c && i && (re.isPlainObject(i) || (o = re.isArray(i))) ? (o ? (o = !1, r = n && re.isArray(n) ? n : []) : r = n && re.isPlainObject(n) ? n : {}, s[t] = re.extend(c, r, i)) : void 0 !== i && (s[t] = i));
                }
            }return s;
        }, re.extend({ expando: "jQuery" + (oe + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(e) {
                throw new Error(e);
            }, noop: function noop() {}, isFunction: function isFunction(e) {
                return "function" === re.type(e);
            }, isArray: Array.isArray, isWindow: function isWindow(e) {
                return null != e && e === e.window;
            }, isNumeric: function isNumeric(e) {
                var t = e && e.toString();return !re.isArray(e) && t - parseFloat(t) + 1 >= 0;
            }, isPlainObject: function isPlainObject(e) {
                var t;if ("object" !== re.type(e) || e.nodeType || re.isWindow(e)) return !1;if (e.constructor && !ne.call(e, "constructor") && !ne.call(e.constructor.prototype || {}, "isPrototypeOf")) return !1;for (t in e) {}return void 0 === t || ne.call(e, t);
            }, isEmptyObject: function isEmptyObject(e) {
                var t;for (t in e) {
                    return !1;
                }return !0;
            }, type: function type(e) {
                return null == e ? e + "" : "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) || "function" == typeof e ? ee[te.call(e)] || "object" : typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e);
            }, globalEval: function globalEval(e) {
                var t,
                    n = eval;e = re.trim(e), e && (1 === e.indexOf("use strict") ? (t = G.createElement("script"), t.text = e, G.head.appendChild(t).parentNode.removeChild(t)) : n(e));
            }, camelCase: function camelCase(e) {
                return e.replace(ae, "ms-").replace(le, ce);
            }, nodeName: function nodeName(e, t) {
                return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
            }, each: function each(e, t) {
                var i,
                    o = 0;if (n(e)) for (i = e.length; i > o && t.call(e[o], o, e[o]) !== !1; o++) {} else for (o in e) {
                    if (t.call(e[o], o, e[o]) === !1) break;
                }return e;
            }, trim: function trim(e) {
                return null == e ? "" : (e + "").replace(se, "");
            }, makeArray: function makeArray(e, t) {
                var i = t || [];return null != e && (n(Object(e)) ? re.merge(i, "string" == typeof e ? [e] : e) : K.call(i, e)), i;
            }, inArray: function inArray(e, t, n) {
                return null == t ? -1 : Z.call(t, e, n);
            }, merge: function merge(e, t) {
                for (var n = +t.length, i = 0, o = e.length; n > i; i++) {
                    e[o++] = t[i];
                }return e.length = o, e;
            }, grep: function grep(e, t, n) {
                for (var i, o = [], r = 0, s = e.length, a = !n; s > r; r++) {
                    i = !t(e[r], r), i !== a && o.push(e[r]);
                }return o;
            }, map: function map(e, t, i) {
                var o,
                    r,
                    s = 0,
                    a = [];if (n(e)) for (o = e.length; o > s; s++) {
                    r = t(e[s], s, i), null != r && a.push(r);
                } else for (s in e) {
                    r = t(e[s], s, i), null != r && a.push(r);
                }return J.apply([], a);
            }, guid: 1, proxy: function proxy(e, t) {
                var n, i, o;return "string" == typeof t && (n = e[t], t = e, e = n), re.isFunction(e) ? (i = Q.call(arguments, 2), o = function o() {
                    return e.apply(t || this, i.concat(Q.call(arguments)));
                }, o.guid = e.guid = e.guid || re.guid++, o) : void 0;
            }, now: Date.now, support: ie }), "function" == typeof Symbol && (re.fn[Symbol.iterator] = V[Symbol.iterator]), re.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            ee["[object " + t + "]"] = t.toLowerCase();
        });var de = function (e) {
            function t(e, t, n, i) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    u,
                    f,
                    h = t && t.ownerDocument,
                    g = t ? t.nodeType : 9;if (n = n || [], "string" != typeof e || !e || 1 !== g && 9 !== g && 11 !== g) return n;if (!i && ((t ? t.ownerDocument || t : _) !== O && D(t), t = t || O, P)) {
                    if (11 !== g && (c = me.exec(e))) if (o = c[1]) {
                        if (9 === g) {
                            if (!(s = t.getElementById(o))) return n;if (s.id === o) return n.push(s), n;
                        } else if (h && (s = h.getElementById(o)) && M(t, s) && s.id === o) return n.push(s), n;
                    } else {
                        if (c[2]) return K.apply(n, t.getElementsByTagName(e)), n;if ((o = c[3]) && x.getElementsByClassName && t.getElementsByClassName) return K.apply(n, t.getElementsByClassName(o)), n;
                    }if (x.qsa && !U[e + " "] && (!L || !L.test(e))) {
                        if (1 !== g) h = t, f = e;else if ("object" !== t.nodeName.toLowerCase()) {
                            for ((a = t.getAttribute("id")) ? a = a.replace(we, "\\$&") : t.setAttribute("id", a = z), u = S(e), r = u.length, l = pe.test(a) ? "#" + a : "[id='" + a + "']"; r--;) {
                                u[r] = l + " " + p(u[r]);
                            }f = u.join(","), h = ye.test(e) && d(t.parentNode) || t;
                        }if (f) try {
                            return K.apply(n, h.querySelectorAll(f)), n;
                        } catch (e) {} finally {
                            a === z && t.removeAttribute("id");
                        }
                    }
                }return E(e.replace(ae, "$1"), t, n, i);
            }function n() {
                function e(n, i) {
                    return t.push(n + " ") > k.cacheLength && delete e[t.shift()], e[n + " "] = i;
                }var t = [];return e;
            }function i(e) {
                return e[z] = !0, e;
            }function o(e) {
                var t = O.createElement("div");try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), t = null;
                }
            }function r(e, t) {
                for (var n = e.split("|"), i = n.length; i--;) {
                    k.attrHandle[n[i]] = t;
                }
            }function s(e, t) {
                var n = t && e,
                    i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || Y) - (~e.sourceIndex || Y);if (i) return i;if (n) for (; n = n.nextSibling;) {
                    if (n === t) return -1;
                }return e ? 1 : -1;
            }function a(e) {
                return function (t) {
                    var n = t.nodeName.toLowerCase();return "input" === n && t.type === e;
                };
            }function l(e) {
                return function (t) {
                    var n = t.nodeName.toLowerCase();return ("input" === n || "button" === n) && t.type === e;
                };
            }function c(e) {
                return i(function (t) {
                    return t = +t, i(function (n, i) {
                        for (var o, r = e([], n.length, t), s = r.length; s--;) {
                            n[o = r[s]] && (n[o] = !(i[o] = n[o]));
                        }
                    });
                });
            }function d(e) {
                return e && "undefined" != typeof e.getElementsByTagName && e;
            }function u() {}function p(e) {
                for (var t = 0, n = e.length, i = ""; n > t; t++) {
                    i += e[t].value;
                }return i;
            }function f(e, t, n) {
                var i = t.dir,
                    o = n && "parentNode" === i,
                    r = R++;return t.first ? function (t, n, r) {
                    for (; t = t[i];) {
                        if (1 === t.nodeType || o) return e(t, n, r);
                    }
                } : function (t, n, s) {
                    var a,
                        l,
                        c,
                        d = [F, r];if (s) {
                        for (; t = t[i];) {
                            if ((1 === t.nodeType || o) && e(t, n, s)) return !0;
                        }
                    } else for (; t = t[i];) {
                        if (1 === t.nodeType || o) {
                            if (c = t[z] || (t[z] = {}), l = c[t.uniqueID] || (c[t.uniqueID] = {}), (a = l[i]) && a[0] === F && a[1] === r) return d[2] = a[2];if (l[i] = d, d[2] = e(t, n, s)) return !0;
                        }
                    }
                };
            }function h(e) {
                return e.length > 1 ? function (t, n, i) {
                    for (var o = e.length; o--;) {
                        if (!e[o](t, n, i)) return !1;
                    }return !0;
                } : e[0];
            }function g(e, n, i) {
                for (var o = 0, r = n.length; r > o; o++) {
                    t(e, n[o], i);
                }return i;
            }function v(e, t, n, i, o) {
                for (var r, s = [], a = 0, l = e.length, c = null != t; l > a; a++) {
                    (r = e[a]) && (n && !n(r, i, o) || (s.push(r), c && t.push(a)));
                }return s;
            }function m(e, t, n, o, r, s) {
                return o && !o[z] && (o = m(o)), r && !r[z] && (r = m(r, s)), i(function (i, s, a, l) {
                    var c,
                        d,
                        u,
                        p = [],
                        f = [],
                        h = s.length,
                        m = i || g(t || "*", a.nodeType ? [a] : a, []),
                        y = !e || !i && t ? m : v(m, p, e, a, l),
                        w = n ? r || (i ? e : h || o) ? [] : s : y;if (n && n(y, w, a, l), o) for (c = v(w, f), o(c, [], a, l), d = c.length; d--;) {
                        (u = c[d]) && (w[f[d]] = !(y[f[d]] = u));
                    }if (i) {
                        if (r || e) {
                            if (r) {
                                for (c = [], d = w.length; d--;) {
                                    (u = w[d]) && c.push(y[d] = u);
                                }r(null, w = [], c, l);
                            }for (d = w.length; d--;) {
                                (u = w[d]) && (c = r ? ee(i, u) : p[d]) > -1 && (i[c] = !(s[c] = u));
                            }
                        }
                    } else w = v(w === s ? w.splice(h, w.length) : w), r ? r(null, s, w, l) : K.apply(s, w);
                });
            }function y(e) {
                for (var t, n, i, o = e.length, r = k.relative[e[0].type], s = r || k.relative[" "], a = r ? 1 : 0, l = f(function (e) {
                    return e === t;
                }, s, !0), c = f(function (e) {
                    return ee(t, e) > -1;
                }, s, !0), d = [function (e, n, i) {
                    var o = !r && (i || n !== A) || ((t = n).nodeType ? l(e, n, i) : c(e, n, i));return t = null, o;
                }]; o > a; a++) {
                    if (n = k.relative[e[a].type]) d = [f(h(d), n)];else {
                        if (n = k.filter[e[a].type].apply(null, e[a].matches), n[z]) {
                            for (i = ++a; o > i && !k.relative[e[i].type]; i++) {}return m(a > 1 && h(d), a > 1 && p(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(ae, "$1"), n, i > a && y(e.slice(a, i)), o > i && y(e = e.slice(i)), o > i && p(e));
                        }d.push(n);
                    }
                }return h(d);
            }function w(e, n) {
                var o = n.length > 0,
                    r = e.length > 0,
                    s = function s(i, _s, a, l, c) {
                    var d,
                        u,
                        p,
                        f = 0,
                        h = "0",
                        g = i && [],
                        m = [],
                        y = A,
                        w = i || r && k.find.TAG("*", c),
                        b = F += null == y ? 1 : Math.random() || .1,
                        x = w.length;for (c && (A = _s === O || _s || c); h !== x && null != (d = w[h]); h++) {
                        if (r && d) {
                            for (u = 0, _s || d.ownerDocument === O || (D(d), a = !P); p = e[u++];) {
                                if (p(d, _s || O, a)) {
                                    l.push(d);break;
                                }
                            }c && (F = b);
                        }o && ((d = !p && d) && f--, i && g.push(d));
                    }if (f += h, o && h !== f) {
                        for (u = 0; p = n[u++];) {
                            p(g, m, _s, a);
                        }if (i) {
                            if (f > 0) for (; h--;) {
                                g[h] || m[h] || (m[h] = Q.call(l));
                            }m = v(m);
                        }K.apply(l, m), c && !i && m.length > 0 && f + n.length > 1 && t.uniqueSort(l);
                    }return c && (F = b, A = y), g;
                };return o ? i(s) : s;
            }var b,
                x,
                k,
                T,
                C,
                S,
                $,
                E,
                A,
                j,
                N,
                D,
                O,
                H,
                P,
                L,
                q,
                I,
                M,
                z = "sizzle" + 1 * new Date(),
                _ = e.document,
                F = 0,
                R = 0,
                W = n(),
                B = n(),
                U = n(),
                X = function X(e, t) {
                return e === t && (N = !0), 0;
            },
                Y = 1 << 31,
                V = {}.hasOwnProperty,
                G = [],
                Q = G.pop,
                J = G.push,
                K = G.push,
                Z = G.slice,
                ee = function ee(e, t) {
                for (var n = 0, i = e.length; i > n; n++) {
                    if (e[n] === t) return n;
                }return -1;
            },
                te = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                ne = "[\\x20\\t\\r\\n\\f]",
                ie = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
                oe = "\\[" + ne + "*(" + ie + ")(?:" + ne + "*([*^$|!~]?=)" + ne + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ie + "))|)" + ne + "*\\]",
                re = ":(" + ie + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + oe + ")*)|.*)\\)|)",
                se = new RegExp(ne + "+", "g"),
                ae = new RegExp("^" + ne + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ne + "+$", "g"),
                le = new RegExp("^" + ne + "*," + ne + "*"),
                ce = new RegExp("^" + ne + "*([>+~]|" + ne + ")" + ne + "*"),
                de = new RegExp("=" + ne + "*([^\\]'\"]*?)" + ne + "*\\]", "g"),
                ue = new RegExp(re),
                pe = new RegExp("^" + ie + "$"),
                fe = { ID: new RegExp("^#(" + ie + ")"), CLASS: new RegExp("^\\.(" + ie + ")"), TAG: new RegExp("^(" + ie + "|[*])"), ATTR: new RegExp("^" + oe), PSEUDO: new RegExp("^" + re), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ne + "*(even|odd|(([+-]|)(\\d*)n|)" + ne + "*(?:([+-]|)" + ne + "*(\\d+)|))" + ne + "*\\)|)", "i"), bool: new RegExp("^(?:" + te + ")$", "i"), needsContext: new RegExp("^" + ne + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ne + "*((?:-\\d)?\\d*)" + ne + "*\\)|)(?=[^-]|$)", "i") },
                he = /^(?:input|select|textarea|button)$/i,
                ge = /^h\d$/i,
                ve = /^[^{]+\{\s*\[native \w/,
                me = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                ye = /[+~]/,
                we = /'|\\/g,
                be = new RegExp("\\\\([\\da-f]{1,6}" + ne + "?|(" + ne + ")|.)", "ig"),
                xe = function xe(e, t, n) {
                var i = "0x" + t - 65536;return i !== i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320);
            },
                ke = function ke() {
                D();
            };try {
                K.apply(G = Z.call(_.childNodes), _.childNodes), G[_.childNodes.length].nodeType;
            } catch (e) {
                K = { apply: G.length ? function (e, t) {
                        J.apply(e, Z.call(t));
                    } : function (e, t) {
                        for (var n = e.length, i = 0; e[n++] = t[i++];) {}e.length = n - 1;
                    } };
            }x = t.support = {}, C = t.isXML = function (e) {
                var t = e && (e.ownerDocument || e).documentElement;return !!t && "HTML" !== t.nodeName;
            }, D = t.setDocument = function (e) {
                var t,
                    n,
                    i = e ? e.ownerDocument || e : _;return i !== O && 9 === i.nodeType && i.documentElement ? (O = i, H = O.documentElement, P = !C(O), (n = O.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", ke, !1) : n.attachEvent && n.attachEvent("onunload", ke)), x.attributes = o(function (e) {
                    return e.className = "i", !e.getAttribute("className");
                }), x.getElementsByTagName = o(function (e) {
                    return e.appendChild(O.createComment("")), !e.getElementsByTagName("*").length;
                }), x.getElementsByClassName = ve.test(O.getElementsByClassName), x.getById = o(function (e) {
                    return H.appendChild(e).id = z, !O.getElementsByName || !O.getElementsByName(z).length;
                }), x.getById ? (k.find.ID = function (e, t) {
                    if ("undefined" != typeof t.getElementById && P) {
                        var n = t.getElementById(e);return n ? [n] : [];
                    }
                }, k.filter.ID = function (e) {
                    var t = e.replace(be, xe);return function (e) {
                        return e.getAttribute("id") === t;
                    };
                }) : (delete k.find.ID, k.filter.ID = function (e) {
                    var t = e.replace(be, xe);return function (e) {
                        var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");return n && n.value === t;
                    };
                }), k.find.TAG = x.getElementsByTagName ? function (e, t) {
                    return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : x.qsa ? t.querySelectorAll(e) : void 0;
                } : function (e, t) {
                    var n,
                        i = [],
                        o = 0,
                        r = t.getElementsByTagName(e);if ("*" === e) {
                        for (; n = r[o++];) {
                            1 === n.nodeType && i.push(n);
                        }return i;
                    }return r;
                }, k.find.CLASS = x.getElementsByClassName && function (e, t) {
                    return "undefined" != typeof t.getElementsByClassName && P ? t.getElementsByClassName(e) : void 0;
                }, q = [], L = [], (x.qsa = ve.test(O.querySelectorAll)) && (o(function (e) {
                    H.appendChild(e).innerHTML = "<a id='" + z + "'></a><select id='" + z + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && L.push("[*^$]=" + ne + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || L.push("\\[" + ne + "*(?:value|" + te + ")"), e.querySelectorAll("[id~=" + z + "-]").length || L.push("~="), e.querySelectorAll(":checked").length || L.push(":checked"), e.querySelectorAll("a#" + z + "+*").length || L.push(".#.+[+~]");
                }), o(function (e) {
                    var t = O.createElement("input");t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && L.push("name" + ne + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || L.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), L.push(",.*:");
                })), (x.matchesSelector = ve.test(I = H.matches || H.webkitMatchesSelector || H.mozMatchesSelector || H.oMatchesSelector || H.msMatchesSelector)) && o(function (e) {
                    x.disconnectedMatch = I.call(e, "div"), I.call(e, "[s!='']:x"), q.push("!=", re);
                }), L = L.length && new RegExp(L.join("|")), q = q.length && new RegExp(q.join("|")), t = ve.test(H.compareDocumentPosition), M = t || ve.test(H.contains) ? function (e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                        i = t && t.parentNode;return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
                } : function (e, t) {
                    if (t) for (; t = t.parentNode;) {
                        if (t === e) return !0;
                    }return !1;
                }, X = t ? function (e, t) {
                    if (e === t) return N = !0, 0;var n = !e.compareDocumentPosition - !t.compareDocumentPosition;return n ? n : (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & n || !x.sortDetached && t.compareDocumentPosition(e) === n ? e === O || e.ownerDocument === _ && M(_, e) ? -1 : t === O || t.ownerDocument === _ && M(_, t) ? 1 : j ? ee(j, e) - ee(j, t) : 0 : 4 & n ? -1 : 1);
                } : function (e, t) {
                    if (e === t) return N = !0, 0;var n,
                        i = 0,
                        o = e.parentNode,
                        r = t.parentNode,
                        a = [e],
                        l = [t];if (!o || !r) return e === O ? -1 : t === O ? 1 : o ? -1 : r ? 1 : j ? ee(j, e) - ee(j, t) : 0;if (o === r) return s(e, t);for (n = e; n = n.parentNode;) {
                        a.unshift(n);
                    }for (n = t; n = n.parentNode;) {
                        l.unshift(n);
                    }for (; a[i] === l[i];) {
                        i++;
                    }return i ? s(a[i], l[i]) : a[i] === _ ? -1 : l[i] === _ ? 1 : 0;
                }, O) : O;
            }, t.matches = function (e, n) {
                return t(e, null, null, n);
            }, t.matchesSelector = function (e, n) {
                if ((e.ownerDocument || e) !== O && D(e), n = n.replace(de, "='$1']"), x.matchesSelector && P && !U[n + " "] && (!q || !q.test(n)) && (!L || !L.test(n))) try {
                    var i = I.call(e, n);if (i || x.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i;
                } catch (e) {}return t(n, O, null, [e]).length > 0;
            }, t.contains = function (e, t) {
                return (e.ownerDocument || e) !== O && D(e), M(e, t);
            }, t.attr = function (e, t) {
                (e.ownerDocument || e) !== O && D(e);var n = k.attrHandle[t.toLowerCase()],
                    i = n && V.call(k.attrHandle, t.toLowerCase()) ? n(e, t, !P) : void 0;return void 0 !== i ? i : x.attributes || !P ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
            }, t.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
            }, t.uniqueSort = function (e) {
                var t,
                    n = [],
                    i = 0,
                    o = 0;if (N = !x.detectDuplicates, j = !x.sortStable && e.slice(0), e.sort(X), N) {
                    for (; t = e[o++];) {
                        t === e[o] && (i = n.push(o));
                    }for (; i--;) {
                        e.splice(n[i], 1);
                    }
                }return j = null, e;
            }, T = t.getText = function (e) {
                var t,
                    n = "",
                    i = 0,
                    o = e.nodeType;if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;for (e = e.firstChild; e; e = e.nextSibling) {
                            n += T(e);
                        }
                    } else if (3 === o || 4 === o) return e.nodeValue;
                } else for (; t = e[i++];) {
                    n += T(t);
                }return n;
            }, k = t.selectors = { cacheLength: 50, createPseudo: i, match: fe, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(e) {
                        return e[1] = e[1].replace(be, xe), e[3] = (e[3] || e[4] || e[5] || "").replace(be, xe), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                    }, CHILD: function CHILD(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e;
                    }, PSEUDO: function PSEUDO(e) {
                        var t,
                            n = !e[6] && e[2];return fe.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && ue.test(n) && (t = S(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
                    } }, filter: { TAG: function TAG(e) {
                        var t = e.replace(be, xe).toLowerCase();return "*" === e ? function () {
                            return !0;
                        } : function (e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t;
                        };
                    }, CLASS: function CLASS(e) {
                        var t = W[e + " "];return t || (t = new RegExp("(^|" + ne + ")" + e + "(" + ne + "|$)")) && W(e, function (e) {
                            return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "");
                        });
                    }, ATTR: function ATTR(e, n, i) {
                        return function (o) {
                            var r = t.attr(o, e);return null == r ? "!=" === n : !n || (r += "", "=" === n ? r === i : "!=" === n ? r !== i : "^=" === n ? i && 0 === r.indexOf(i) : "*=" === n ? i && r.indexOf(i) > -1 : "$=" === n ? i && r.slice(-i.length) === i : "~=" === n ? (" " + r.replace(se, " ") + " ").indexOf(i) > -1 : "|=" === n && (r === i || r.slice(0, i.length + 1) === i + "-"));
                        };
                    }, CHILD: function CHILD(e, t, n, i, o) {
                        var r = "nth" !== e.slice(0, 3),
                            s = "last" !== e.slice(-4),
                            a = "of-type" === t;return 1 === i && 0 === o ? function (e) {
                            return !!e.parentNode;
                        } : function (t, n, l) {
                            var c,
                                d,
                                u,
                                p,
                                f,
                                h,
                                g = r !== s ? "nextSibling" : "previousSibling",
                                v = t.parentNode,
                                m = a && t.nodeName.toLowerCase(),
                                y = !l && !a,
                                w = !1;if (v) {
                                if (r) {
                                    for (; g;) {
                                        for (p = t; p = p[g];) {
                                            if (a ? p.nodeName.toLowerCase() === m : 1 === p.nodeType) return !1;
                                        }h = g = "only" === e && !h && "nextSibling";
                                    }return !0;
                                }if (h = [s ? v.firstChild : v.lastChild], s && y) {
                                    for (p = v, u = p[z] || (p[z] = {}), d = u[p.uniqueID] || (u[p.uniqueID] = {}), c = d[e] || [], f = c[0] === F && c[1], w = f && c[2], p = f && v.childNodes[f]; p = ++f && p && p[g] || (w = f = 0) || h.pop();) {
                                        if (1 === p.nodeType && ++w && p === t) {
                                            d[e] = [F, f, w];break;
                                        }
                                    }
                                } else if (y && (p = t, u = p[z] || (p[z] = {}), d = u[p.uniqueID] || (u[p.uniqueID] = {}), c = d[e] || [], f = c[0] === F && c[1], w = f), w === !1) for (; (p = ++f && p && p[g] || (w = f = 0) || h.pop()) && ((a ? p.nodeName.toLowerCase() !== m : 1 !== p.nodeType) || !++w || (y && (u = p[z] || (p[z] = {}), d = u[p.uniqueID] || (u[p.uniqueID] = {}), d[e] = [F, w]), p !== t));) {}return w -= o, w === i || w % i === 0 && w / i >= 0;
                            }
                        };
                    }, PSEUDO: function PSEUDO(e, n) {
                        var o,
                            r = k.pseudos[e] || k.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);return r[z] ? r(n) : r.length > 1 ? (o = [e, e, "", n], k.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function (e, t) {
                            for (var i, o = r(e, n), s = o.length; s--;) {
                                i = ee(e, o[s]), e[i] = !(t[i] = o[s]);
                            }
                        }) : function (e) {
                            return r(e, 0, o);
                        }) : r;
                    } }, pseudos: { not: i(function (e) {
                        var t = [],
                            n = [],
                            o = $(e.replace(ae, "$1"));return o[z] ? i(function (e, t, n, i) {
                            for (var r, s = o(e, null, i, []), a = e.length; a--;) {
                                (r = s[a]) && (e[a] = !(t[a] = r));
                            }
                        }) : function (e, i, r) {
                            return t[0] = e, o(t, null, r, n), t[0] = null, !n.pop();
                        };
                    }), has: i(function (e) {
                        return function (n) {
                            return t(e, n).length > 0;
                        };
                    }), contains: i(function (e) {
                        return e = e.replace(be, xe), function (t) {
                            return (t.textContent || t.innerText || T(t)).indexOf(e) > -1;
                        };
                    }), lang: i(function (e) {
                        return pe.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(be, xe).toLowerCase(), function (t) {
                            var n;do {
                                if (n = P ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return n = n.toLowerCase(), n === e || 0 === n.indexOf(e + "-");
                            } while ((t = t.parentNode) && 1 === t.nodeType);return !1;
                        };
                    }), target: function target(t) {
                        var n = e.location && e.location.hash;return n && n.slice(1) === t.id;
                    }, root: function root(e) {
                        return e === H;
                    }, focus: function focus(e) {
                        return e === O.activeElement && (!O.hasFocus || O.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                    }, enabled: function enabled(e) {
                        return e.disabled === !1;
                    }, disabled: function disabled(e) {
                        return e.disabled === !0;
                    }, checked: function checked(e) {
                        var t = e.nodeName.toLowerCase();return "input" === t && !!e.checked || "option" === t && !!e.selected;
                    }, selected: function selected(e) {
                        return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
                    }, empty: function empty(e) {
                        for (e = e.firstChild; e; e = e.nextSibling) {
                            if (e.nodeType < 6) return !1;
                        }return !0;
                    }, parent: function parent(e) {
                        return !k.pseudos.empty(e);
                    }, header: function header(e) {
                        return ge.test(e.nodeName);
                    }, input: function input(e) {
                        return he.test(e.nodeName);
                    }, button: function button(e) {
                        var t = e.nodeName.toLowerCase();return "input" === t && "button" === e.type || "button" === t;
                    }, text: function text(e) {
                        var t;return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                    }, first: c(function () {
                        return [0];
                    }), last: c(function (e, t) {
                        return [t - 1];
                    }), eq: c(function (e, t, n) {
                        return [0 > n ? n + t : n];
                    }), even: c(function (e, t) {
                        for (var n = 0; t > n; n += 2) {
                            e.push(n);
                        }return e;
                    }), odd: c(function (e, t) {
                        for (var n = 1; t > n; n += 2) {
                            e.push(n);
                        }return e;
                    }), lt: c(function (e, t, n) {
                        for (var i = 0 > n ? n + t : n; --i >= 0;) {
                            e.push(i);
                        }return e;
                    }), gt: c(function (e, t, n) {
                        for (var i = 0 > n ? n + t : n; ++i < t;) {
                            e.push(i);
                        }return e;
                    }) } }, k.pseudos.nth = k.pseudos.eq;for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
                k.pseudos[b] = a(b);
            }for (b in { submit: !0, reset: !0 }) {
                k.pseudos[b] = l(b);
            }return u.prototype = k.filters = k.pseudos, k.setFilters = new u(), S = t.tokenize = function (e, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    d = B[e + " "];if (d) return n ? 0 : d.slice(0);for (a = e, l = [], c = k.preFilter; a;) {
                    i && !(o = le.exec(a)) || (o && (a = a.slice(o[0].length) || a), l.push(r = [])), i = !1, (o = ce.exec(a)) && (i = o.shift(), r.push({ value: i, type: o[0].replace(ae, " ") }), a = a.slice(i.length));for (s in k.filter) {
                        !(o = fe[s].exec(a)) || c[s] && !(o = c[s](o)) || (i = o.shift(), r.push({ value: i, type: s, matches: o }), a = a.slice(i.length));
                    }if (!i) break;
                }return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
            }, $ = t.compile = function (e, t) {
                var n,
                    i = [],
                    o = [],
                    r = U[e + " "];if (!r) {
                    for (t || (t = S(e)), n = t.length; n--;) {
                        r = y(t[n]), r[z] ? i.push(r) : o.push(r);
                    }r = U(e, w(o, i)), r.selector = e;
                }return r;
            }, E = t.select = function (e, t, n, i) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    c = "function" == typeof e && e,
                    u = !i && S(e = c.selector || e);if (n = n || [], 1 === u.length) {
                    if (r = u[0] = u[0].slice(0), r.length > 2 && "ID" === (s = r[0]).type && x.getById && 9 === t.nodeType && P && k.relative[r[1].type]) {
                        if (t = (k.find.ID(s.matches[0].replace(be, xe), t) || [])[0], !t) return n;c && (t = t.parentNode), e = e.slice(r.shift().value.length);
                    }for (o = fe.needsContext.test(e) ? 0 : r.length; o-- && (s = r[o], !k.relative[a = s.type]);) {
                        if ((l = k.find[a]) && (i = l(s.matches[0].replace(be, xe), ye.test(r[0].type) && d(t.parentNode) || t))) {
                            if (r.splice(o, 1), e = i.length && p(r), !e) return K.apply(n, i), n;break;
                        }
                    }
                }return (c || $(e, u))(i, t, !P, n, !t || ye.test(e) && d(t.parentNode) || t), n;
            }, x.sortStable = z.split("").sort(X).join("") === z, x.detectDuplicates = !!N, D(), x.sortDetached = o(function (e) {
                return 1 & e.compareDocumentPosition(O.createElement("div"));
            }), o(function (e) {
                return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
            }) || r("type|href|height|width", function (e, t, n) {
                return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
            }), x.attributes && o(function (e) {
                return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
            }) || r("value", function (e, t, n) {
                return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue;
            }), o(function (e) {
                return null == e.getAttribute("disabled");
            }) || r(te, function (e, t, n) {
                var i;return n ? void 0 : e[t] === !0 ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
            }), t;
        }(e);re.find = de, re.expr = de.selectors, re.expr[":"] = re.expr.pseudos, re.uniqueSort = re.unique = de.uniqueSort, re.text = de.getText, re.isXMLDoc = de.isXML, re.contains = de.contains;var ue = function ue(e, t, n) {
            for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;) {
                if (1 === e.nodeType) {
                    if (o && re(e).is(n)) break;i.push(e);
                }
            }return i;
        },
            pe = function pe(e, t) {
            for (var n = []; e; e = e.nextSibling) {
                1 === e.nodeType && e !== t && n.push(e);
            }return n;
        },
            fe = re.expr.match.needsContext,
            he = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
            ge = /^.[^:#\[\.,]*$/;re.filter = function (e, t, n) {
            var i = t[0];return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? re.find.matchesSelector(i, e) ? [i] : [] : re.find.matches(e, re.grep(t, function (e) {
                return 1 === e.nodeType;
            }));
        }, re.fn.extend({ find: function find(e) {
                var t,
                    n = this.length,
                    i = [],
                    o = this;if ("string" != typeof e) return this.pushStack(re(e).filter(function () {
                    for (t = 0; n > t; t++) {
                        if (re.contains(o[t], this)) return !0;
                    }
                }));for (t = 0; n > t; t++) {
                    re.find(e, o[t], i);
                }return i = this.pushStack(n > 1 ? re.unique(i) : i), i.selector = this.selector ? this.selector + " " + e : e, i;
            }, filter: function filter(e) {
                return this.pushStack(i(this, e || [], !1));
            }, not: function not(e) {
                return this.pushStack(i(this, e || [], !0));
            }, is: function is(e) {
                return !!i(this, "string" == typeof e && fe.test(e) ? re(e) : e || [], !1).length;
            } });var ve,
            me = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
            ye = re.fn.init = function (e, t, n) {
            var i, o;if (!e) return this;if (n = n || ve, "string" == typeof e) {
                if (i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : me.exec(e), !i || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);if (i[1]) {
                    if (t = t instanceof re ? t[0] : t, re.merge(this, re.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : G, !0)), he.test(i[1]) && re.isPlainObject(t)) for (i in t) {
                        re.isFunction(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                    }return this;
                }return o = G.getElementById(i[2]), o && o.parentNode && (this.length = 1, this[0] = o), this.context = G, this.selector = e, this;
            }return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : re.isFunction(e) ? void 0 !== n.ready ? n.ready(e) : e(re) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), re.makeArray(e, this));
        };ye.prototype = re.fn, ve = re(G);var we = /^(?:parents|prev(?:Until|All))/,
            be = { children: !0, contents: !0, next: !0, prev: !0 };re.fn.extend({ has: function has(e) {
                var t = re(e, this),
                    n = t.length;return this.filter(function () {
                    for (var e = 0; n > e; e++) {
                        if (re.contains(this, t[e])) return !0;
                    }
                });
            }, closest: function closest(e, t) {
                for (var n, i = 0, o = this.length, r = [], s = fe.test(e) || "string" != typeof e ? re(e, t || this.context) : 0; o > i; i++) {
                    for (n = this[i]; n && n !== t; n = n.parentNode) {
                        if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && re.find.matchesSelector(n, e))) {
                            r.push(n);break;
                        }
                    }
                }return this.pushStack(r.length > 1 ? re.uniqueSort(r) : r);
            }, index: function index(e) {
                return e ? "string" == typeof e ? Z.call(re(e), this[0]) : Z.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            }, add: function add(e, t) {
                return this.pushStack(re.uniqueSort(re.merge(this.get(), re(e, t))));
            }, addBack: function addBack(e) {
                return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
            } }), re.each({ parent: function parent(e) {
                var t = e.parentNode;return t && 11 !== t.nodeType ? t : null;
            }, parents: function parents(e) {
                return ue(e, "parentNode");
            }, parentsUntil: function parentsUntil(e, t, n) {
                return ue(e, "parentNode", n);
            }, next: function next(e) {
                return o(e, "nextSibling");
            }, prev: function prev(e) {
                return o(e, "previousSibling");
            }, nextAll: function nextAll(e) {
                return ue(e, "nextSibling");
            }, prevAll: function prevAll(e) {
                return ue(e, "previousSibling");
            }, nextUntil: function nextUntil(e, t, n) {
                return ue(e, "nextSibling", n);
            }, prevUntil: function prevUntil(e, t, n) {
                return ue(e, "previousSibling", n);
            }, siblings: function siblings(e) {
                return pe((e.parentNode || {}).firstChild, e);
            }, children: function children(e) {
                return pe(e.firstChild);
            }, contents: function contents(e) {
                return e.contentDocument || re.merge([], e.childNodes);
            } }, function (e, t) {
            re.fn[e] = function (n, i) {
                var o = re.map(this, t, n);return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = re.filter(i, o)), this.length > 1 && (be[e] || re.uniqueSort(o), we.test(e) && o.reverse()), this.pushStack(o);
            };
        });var xe = /\S+/g;re.Callbacks = function (e) {
            e = "string" == typeof e ? r(e) : re.extend({}, e);var t,
                n,
                i,
                o,
                s = [],
                a = [],
                l = -1,
                c = function c() {
                for (o = e.once, i = t = !0; a.length; l = -1) {
                    for (n = a.shift(); ++l < s.length;) {
                        s[l].apply(n[0], n[1]) === !1 && e.stopOnFalse && (l = s.length, n = !1);
                    }
                }e.memory || (n = !1), t = !1, o && (s = n ? [] : "");
            },
                d = { add: function add() {
                    return s && (n && !t && (l = s.length - 1, a.push(n)), function t(n) {
                        re.each(n, function (n, i) {
                            re.isFunction(i) ? e.unique && d.has(i) || s.push(i) : i && i.length && "string" !== re.type(i) && t(i);
                        });
                    }(arguments), n && !t && c()), this;
                }, remove: function remove() {
                    return re.each(arguments, function (e, t) {
                        for (var n; (n = re.inArray(t, s, n)) > -1;) {
                            s.splice(n, 1), l >= n && l--;
                        }
                    }), this;
                }, has: function has(e) {
                    return e ? re.inArray(e, s) > -1 : s.length > 0;
                }, empty: function empty() {
                    return s && (s = []), this;
                }, disable: function disable() {
                    return o = a = [], s = n = "", this;
                }, disabled: function disabled() {
                    return !s;
                }, lock: function lock() {
                    return o = a = [], n || (s = n = ""), this;
                }, locked: function locked() {
                    return !!o;
                }, fireWith: function fireWith(e, n) {
                    return o || (n = n || [], n = [e, n.slice ? n.slice() : n], a.push(n), t || c()), this;
                }, fire: function fire() {
                    return d.fireWith(this, arguments), this;
                }, fired: function fired() {
                    return !!i;
                } };return d;
        }, re.extend({ Deferred: function Deferred(e) {
                var t = [["resolve", "done", re.Callbacks("once memory"), "resolved"], ["reject", "fail", re.Callbacks("once memory"), "rejected"], ["notify", "progress", re.Callbacks("memory")]],
                    n = "pending",
                    i = { state: function state() {
                        return n;
                    }, always: function always() {
                        return o.done(arguments).fail(arguments), this;
                    }, then: function then() {
                        var e = arguments;return re.Deferred(function (n) {
                            re.each(t, function (t, r) {
                                var s = re.isFunction(e[t]) && e[t];o[r[1]](function () {
                                    var e = s && s.apply(this, arguments);e && re.isFunction(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[r[0] + "With"](this === i ? n.promise() : this, s ? [e] : arguments);
                                });
                            }), e = null;
                        }).promise();
                    }, promise: function promise(e) {
                        return null != e ? re.extend(e, i) : i;
                    } },
                    o = {};return i.pipe = i.then, re.each(t, function (e, r) {
                    var s = r[2],
                        a = r[3];i[r[1]] = s.add, a && s.add(function () {
                        n = a;
                    }, t[1 ^ e][2].disable, t[2][2].lock), o[r[0]] = function () {
                        return o[r[0] + "With"](this === o ? i : this, arguments), this;
                    }, o[r[0] + "With"] = s.fireWith;
                }), i.promise(o), e && e.call(o, o), o;
            }, when: function when(e) {
                var t,
                    n,
                    i,
                    o = 0,
                    r = Q.call(arguments),
                    s = r.length,
                    a = 1 !== s || e && re.isFunction(e.promise) ? s : 0,
                    l = 1 === a ? e : re.Deferred(),
                    c = function c(e, n, i) {
                    return function (o) {
                        n[e] = this, i[e] = arguments.length > 1 ? Q.call(arguments) : o, i === t ? l.notifyWith(n, i) : --a || l.resolveWith(n, i);
                    };
                };if (s > 1) for (t = new Array(s), n = new Array(s), i = new Array(s); s > o; o++) {
                    r[o] && re.isFunction(r[o].promise) ? r[o].promise().progress(c(o, n, t)).done(c(o, i, r)).fail(l.reject) : --a;
                }return a || l.resolveWith(i, r), l.promise();
            } });var ke;re.fn.ready = function (e) {
            return re.ready.promise().done(e), this;
        }, re.extend({ isReady: !1, readyWait: 1, holdReady: function holdReady(e) {
                e ? re.readyWait++ : re.ready(!0);
            }, ready: function ready(e) {
                (e === !0 ? --re.readyWait : re.isReady) || (re.isReady = !0, e !== !0 && --re.readyWait > 0 || (ke.resolveWith(G, [re]), re.fn.triggerHandler && (re(G).triggerHandler("ready"), re(G).off("ready"))));
            } }), re.ready.promise = function (t) {
            return ke || (ke = re.Deferred(), "complete" === G.readyState || "loading" !== G.readyState && !G.documentElement.doScroll ? e.setTimeout(re.ready) : (G.addEventListener("DOMContentLoaded", s), e.addEventListener("load", s))), ke.promise(t);
        }, re.ready.promise();var Te = function Te(e, t, n, i, o, r, s) {
            var a = 0,
                l = e.length,
                c = null == n;if ("object" === re.type(n)) {
                o = !0;for (a in n) {
                    Te(e, t, a, n[a], !0, r, s);
                }
            } else if (void 0 !== i && (o = !0, re.isFunction(i) || (s = !0), c && (s ? (t.call(e, i), t = null) : (c = t, t = function t(e, _t2, n) {
                return c.call(re(e), n);
            })), t)) for (; l > a; a++) {
                t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
            }return o ? e : c ? t.call(e) : l ? t(e[0], n) : r;
        },
            Ce = function Ce(e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        };a.uid = 1, a.prototype = { register: function register(e, t) {
                var n = t || {};return e.nodeType ? e[this.expando] = n : Object.defineProperty(e, this.expando, { value: n, writable: !0, configurable: !0 }), e[this.expando];
            }, cache: function cache(e) {
                if (!Ce(e)) return {};var t = e[this.expando];return t || (t = {}, Ce(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
            }, set: function set(e, t, n) {
                var i,
                    o = this.cache(e);if ("string" == typeof t) o[t] = n;else for (i in t) {
                    o[i] = t[i];
                }return o;
            }, get: function get(e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][t];
            }, access: function access(e, t, n) {
                var i;return void 0 === t || t && "string" == typeof t && void 0 === n ? (i = this.get(e, t), void 0 !== i ? i : this.get(e, re.camelCase(t))) : (this.set(e, t, n), void 0 !== n ? n : t);
            }, remove: function remove(e, t) {
                var n,
                    i,
                    o,
                    r = e[this.expando];if (void 0 !== r) {
                    if (void 0 === t) this.register(e);else {
                        re.isArray(t) ? i = t.concat(t.map(re.camelCase)) : (o = re.camelCase(t), t in r ? i = [t, o] : (i = o, i = i in r ? [i] : i.match(xe) || [])), n = i.length;for (; n--;) {
                            delete r[i[n]];
                        }
                    }(void 0 === t || re.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
                }
            }, hasData: function hasData(e) {
                var t = e[this.expando];return void 0 !== t && !re.isEmptyObject(t);
            } };var Se = new a(),
            $e = new a(),
            Ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            Ae = /[A-Z]/g;re.extend({ hasData: function hasData(e) {
                return $e.hasData(e) || Se.hasData(e);
            }, data: function data(e, t, n) {
                return $e.access(e, t, n);
            }, removeData: function removeData(e, t) {
                $e.remove(e, t);
            }, _data: function _data(e, t, n) {
                return Se.access(e, t, n);
            }, _removeData: function _removeData(e, t) {
                Se.remove(e, t);
            } }), re.fn.extend({ data: function data(e, t) {
                var n,
                    i,
                    o,
                    r = this[0],
                    s = r && r.attributes;if (void 0 === e) {
                    if (this.length && (o = $e.get(r), 1 === r.nodeType && !Se.get(r, "hasDataAttrs"))) {
                        for (n = s.length; n--;) {
                            s[n] && (i = s[n].name, 0 === i.indexOf("data-") && (i = re.camelCase(i.slice(5)), l(r, i, o[i])));
                        }Se.set(r, "hasDataAttrs", !0);
                    }return o;
                }return "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) ? this.each(function () {
                    $e.set(this, e);
                }) : Te(this, function (t) {
                    var n, i;if (r && void 0 === t) {
                        if (n = $e.get(r, e) || $e.get(r, e.replace(Ae, "-$&").toLowerCase()), void 0 !== n) return n;if (i = re.camelCase(e), n = $e.get(r, i), void 0 !== n) return n;if (n = l(r, i, void 0), void 0 !== n) return n;
                    } else i = re.camelCase(e), this.each(function () {
                        var n = $e.get(this, i);$e.set(this, i, t), e.indexOf("-") > -1 && void 0 !== n && $e.set(this, e, t);
                    });
                }, null, t, arguments.length > 1, null, !0);
            }, removeData: function removeData(e) {
                return this.each(function () {
                    $e.remove(this, e);
                });
            } }), re.extend({ queue: function queue(e, t, n) {
                var i;return e ? (t = (t || "fx") + "queue", i = Se.get(e, t), n && (!i || re.isArray(n) ? i = Se.access(e, t, re.makeArray(n)) : i.push(n)), i || []) : void 0;
            }, dequeue: function dequeue(e, t) {
                t = t || "fx";var n = re.queue(e, t),
                    i = n.length,
                    o = n.shift(),
                    r = re._queueHooks(e, t),
                    s = function s() {
                    re.dequeue(e, t);
                };"inprogress" === o && (o = n.shift(), i--), o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, s, r)), !i && r && r.empty.fire();
            }, _queueHooks: function _queueHooks(e, t) {
                var n = t + "queueHooks";return Se.get(e, n) || Se.access(e, n, { empty: re.Callbacks("once memory").add(function () {
                        Se.remove(e, [t + "queue", n]);
                    }) });
            } }), re.fn.extend({ queue: function queue(e, t) {
                var n = 2;return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? re.queue(this[0], e) : void 0 === t ? this : this.each(function () {
                    var n = re.queue(this, e, t);re._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && re.dequeue(this, e);
                });
            }, dequeue: function dequeue(e) {
                return this.each(function () {
                    re.dequeue(this, e);
                });
            }, clearQueue: function clearQueue(e) {
                return this.queue(e || "fx", []);
            }, promise: function promise(e, t) {
                var n,
                    i = 1,
                    o = re.Deferred(),
                    r = this,
                    s = this.length,
                    a = function a() {
                    --i || o.resolveWith(r, [r]);
                };for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;) {
                    n = Se.get(r[s], e + "queueHooks"), n && n.empty && (i++, n.empty.add(a));
                }return a(), o.promise(t);
            } });var je = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            Ne = new RegExp("^(?:([+-])=|)(" + je + ")([a-z%]*)$", "i"),
            De = ["Top", "Right", "Bottom", "Left"],
            Oe = function Oe(e, t) {
            return e = t || e, "none" === re.css(e, "display") || !re.contains(e.ownerDocument, e);
        },
            He = /^(?:checkbox|radio)$/i,
            Pe = /<([\w:-]+)/,
            Le = /^$|\/(?:java|ecma)script/i,
            qe = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };qe.optgroup = qe.option, qe.tbody = qe.tfoot = qe.colgroup = qe.caption = qe.thead, qe.th = qe.td;var Ie = /<|&#?\w+;/;!function () {
            var e = G.createDocumentFragment(),
                t = e.appendChild(G.createElement("div")),
                n = G.createElement("input");n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), t.appendChild(n), ie.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, t.innerHTML = "<textarea>x</textarea>", ie.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue;
        }();var Me = /^key/,
            ze = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
            _e = /^([^.]*)(?:\.(.+)|)/;re.event = { global: {}, add: function add(e, t, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    f,
                    h,
                    g,
                    v = Se.get(e);if (v) for (n.handler && (r = n, n = r.handler, o = r.selector), n.guid || (n.guid = re.guid++), (l = v.events) || (l = v.events = {}), (s = v.handle) || (s = v.handle = function (t) {
                    return "undefined" != typeof re && re.event.triggered !== t.type ? re.event.dispatch.apply(e, arguments) : void 0;
                }), t = (t || "").match(xe) || [""], c = t.length; c--;) {
                    a = _e.exec(t[c]) || [], f = g = a[1], h = (a[2] || "").split(".").sort(), f && (u = re.event.special[f] || {}, f = (o ? u.delegateType : u.bindType) || f, u = re.event.special[f] || {}, d = re.extend({ type: f, origType: g, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && re.expr.match.needsContext.test(o), namespace: h.join(".") }, r), (p = l[f]) || (p = l[f] = [], p.delegateCount = 0, u.setup && u.setup.call(e, i, h, s) !== !1 || e.addEventListener && e.addEventListener(f, s)), u.add && (u.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)), o ? p.splice(p.delegateCount++, 0, d) : p.push(d), re.event.global[f] = !0);
                }
            }, remove: function remove(e, t, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p,
                    f,
                    h,
                    g,
                    v = Se.hasData(e) && Se.get(e);if (v && (l = v.events)) {
                    for (t = (t || "").match(xe) || [""], c = t.length; c--;) {
                        if (a = _e.exec(t[c]) || [], f = g = a[1], h = (a[2] || "").split(".").sort(), f) {
                            for (u = re.event.special[f] || {}, f = (i ? u.delegateType : u.bindType) || f, p = l[f] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) {
                                d = p[r], !o && g !== d.origType || n && n.guid !== d.guid || a && !a.test(d.namespace) || i && i !== d.selector && ("**" !== i || !d.selector) || (p.splice(r, 1), d.selector && p.delegateCount--, u.remove && u.remove.call(e, d));
                            }s && !p.length && (u.teardown && u.teardown.call(e, h, v.handle) !== !1 || re.removeEvent(e, f, v.handle), delete l[f]);
                        } else for (f in l) {
                            re.event.remove(e, f + t[c], n, i, !0);
                        }
                    }re.isEmptyObject(l) && Se.remove(e, "handle events");
                }
            }, dispatch: function dispatch(e) {
                e = re.event.fix(e);var t,
                    n,
                    i,
                    o,
                    r,
                    s = [],
                    a = Q.call(arguments),
                    l = (Se.get(this, "events") || {})[e.type] || [],
                    c = re.event.special[e.type] || {};if (a[0] = e, e.delegateTarget = this, !c.preDispatch || c.preDispatch.call(this, e) !== !1) {
                    for (s = re.event.handlers.call(this, e, l), t = 0; (o = s[t++]) && !e.isPropagationStopped();) {
                        for (e.currentTarget = o.elem, n = 0; (r = o.handlers[n++]) && !e.isImmediatePropagationStopped();) {
                            e.rnamespace && !e.rnamespace.test(r.namespace) || (e.handleObj = r, e.data = r.data, i = ((re.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a), void 0 !== i && (e.result = i) === !1 && (e.preventDefault(), e.stopPropagation()));
                        }
                    }return c.postDispatch && c.postDispatch.call(this, e), e.result;
                }
            }, handlers: function handlers(e, t) {
                var n,
                    i,
                    o,
                    r,
                    s = [],
                    a = t.delegateCount,
                    l = e.target;if (a && l.nodeType && ("click" !== e.type || isNaN(e.button) || e.button < 1)) for (; l !== this; l = l.parentNode || this) {
                    if (1 === l.nodeType && (l.disabled !== !0 || "click" !== e.type)) {
                        for (i = [], n = 0; a > n; n++) {
                            r = t[n], o = r.selector + " ", void 0 === i[o] && (i[o] = r.needsContext ? re(o, this).index(l) > -1 : re.find(o, this, null, [l]).length), i[o] && i.push(r);
                        }i.length && s.push({ elem: l, handlers: i });
                    }
                }return a < t.length && s.push({ elem: this, handlers: t.slice(a) }), s;
            }, props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(e, t) {
                    return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
                } }, mouseHooks: { props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(e, t) {
                    var n,
                        i,
                        o,
                        r = t.button;return null == e.pageX && null != t.clientX && (n = e.target.ownerDocument || G, i = n.documentElement, o = n.body, e.pageX = t.clientX + (i && i.scrollLeft || o && o.scrollLeft || 0) - (i && i.clientLeft || o && o.clientLeft || 0), e.pageY = t.clientY + (i && i.scrollTop || o && o.scrollTop || 0) - (i && i.clientTop || o && o.clientTop || 0)), e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0), e;
                } }, fix: function fix(e) {
                if (e[re.expando]) return e;var t,
                    n,
                    i,
                    o = e.type,
                    r = e,
                    s = this.fixHooks[o];for (s || (this.fixHooks[o] = s = ze.test(o) ? this.mouseHooks : Me.test(o) ? this.keyHooks : {}), i = s.props ? this.props.concat(s.props) : this.props, e = new re.Event(r), t = i.length; t--;) {
                    n = i[t], e[n] = r[n];
                }return e.target || (e.target = G), 3 === e.target.nodeType && (e.target = e.target.parentNode), s.filter ? s.filter(e, r) : e;
            }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
                        return this !== g() && this.focus ? (this.focus(), !1) : void 0;
                    }, delegateType: "focusin" }, blur: { trigger: function trigger() {
                        return this === g() && this.blur ? (this.blur(), !1) : void 0;
                    }, delegateType: "focusout" }, click: { trigger: function trigger() {
                        return "checkbox" === this.type && this.click && re.nodeName(this, "input") ? (this.click(), !1) : void 0;
                    }, _default: function _default(e) {
                        return re.nodeName(e.target, "a");
                    } }, beforeunload: { postDispatch: function postDispatch(e) {
                        void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                    } } } }, re.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }, re.Event = function (e, t) {
            return this instanceof re.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && e.returnValue === !1 ? f : h) : this.type = e, t && re.extend(this, t), this.timeStamp = e && e.timeStamp || re.now(), void (this[re.expando] = !0)) : new re.Event(e, t);
        }, re.Event.prototype = { constructor: re.Event, isDefaultPrevented: h, isPropagationStopped: h, isImmediatePropagationStopped: h, preventDefault: function preventDefault() {
                var e = this.originalEvent;this.isDefaultPrevented = f, e && e.preventDefault();
            }, stopPropagation: function stopPropagation() {
                var e = this.originalEvent;this.isPropagationStopped = f, e && e.stopPropagation();
            }, stopImmediatePropagation: function stopImmediatePropagation() {
                var e = this.originalEvent;this.isImmediatePropagationStopped = f, e && e.stopImmediatePropagation(), this.stopPropagation();
            } }, re.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
            re.event.special[e] = { delegateType: t, bindType: t, handle: function handle(e) {
                    var n,
                        i = this,
                        o = e.relatedTarget,
                        r = e.handleObj;return o && (o === i || re.contains(i, o)) || (e.type = r.origType, n = r.handler.apply(this, arguments), e.type = t), n;
                } };
        }), re.fn.extend({ on: function on(e, t, n, i) {
                return v(this, e, t, n, i);
            }, one: function one(e, t, n, i) {
                return v(this, e, t, n, i, 1);
            }, off: function off(e, t, n) {
                var i, o;if (e && e.preventDefault && e.handleObj) return i = e.handleObj, re(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;if ("object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e))) {
                    for (o in e) {
                        this.off(o, t, e[o]);
                    }return this;
                }return t !== !1 && "function" != typeof t || (n = t, t = void 0), n === !1 && (n = h), this.each(function () {
                    re.event.remove(this, e, n, t);
                });
            } });var Fe = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
            Re = /<script|<style|<link/i,
            We = /checked\s*(?:[^=]|=\s*.checked.)/i,
            Be = /^true\/(.*)/,
            Ue = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;re.extend({ htmlPrefilter: function htmlPrefilter(e) {
                return e.replace(Fe, "<$1></$2>");
            }, clone: function clone(e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a = e.cloneNode(!0),
                    l = re.contains(e.ownerDocument, e);if (!(ie.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || re.isXMLDoc(e))) for (s = d(a), r = d(e), i = 0, o = r.length; o > i; i++) {
                    x(r[i], s[i]);
                }if (t) if (n) for (r = r || d(e), s = s || d(a), i = 0, o = r.length; o > i; i++) {
                    b(r[i], s[i]);
                } else b(e, a);return s = d(a, "script"), s.length > 0 && u(s, !l && d(e, "script")), a;
            }, cleanData: function cleanData(e) {
                for (var t, n, i, o = re.event.special, r = 0; void 0 !== (n = e[r]); r++) {
                    if (Ce(n)) {
                        if (t = n[Se.expando]) {
                            if (t.events) for (i in t.events) {
                                o[i] ? re.event.remove(n, i) : re.removeEvent(n, i, t.handle);
                            }n[Se.expando] = void 0;
                        }n[$e.expando] && (n[$e.expando] = void 0);
                    }
                }
            } }), re.fn.extend({ domManip: k, detach: function detach(e) {
                return T(this, e, !0);
            }, remove: function remove(e) {
                return T(this, e);
            }, text: function text(e) {
                return Te(this, function (e) {
                    return void 0 === e ? re.text(this) : this.empty().each(function () {
                        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
                    });
                }, null, e, arguments.length);
            }, append: function append() {
                return k(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = m(this, e);t.appendChild(e);
                    }
                });
            }, prepend: function prepend() {
                return k(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = m(this, e);t.insertBefore(e, t.firstChild);
                    }
                });
            }, before: function before() {
                return k(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            }, after: function after() {
                return k(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            }, empty: function empty() {
                for (var e, t = 0; null != (e = this[t]); t++) {
                    1 === e.nodeType && (re.cleanData(d(e, !1)), e.textContent = "");
                }return this;
            }, clone: function clone(e, t) {
                return e = null != e && e, t = null == t ? e : t, this.map(function () {
                    return re.clone(this, e, t);
                });
            }, html: function html(e) {
                return Te(this, function (e) {
                    var t = this[0] || {},
                        n = 0,
                        i = this.length;if (void 0 === e && 1 === t.nodeType) return t.innerHTML;if ("string" == typeof e && !Re.test(e) && !qe[(Pe.exec(e) || ["", ""])[1].toLowerCase()]) {
                        e = re.htmlPrefilter(e);try {
                            for (; i > n; n++) {
                                t = this[n] || {}, 1 === t.nodeType && (re.cleanData(d(t, !1)), t.innerHTML = e);
                            }t = 0;
                        } catch (e) {}
                    }t && this.empty().append(e);
                }, null, e, arguments.length);
            }, replaceWith: function replaceWith() {
                var e = [];return k(this, arguments, function (t) {
                    var n = this.parentNode;re.inArray(this, e) < 0 && (re.cleanData(d(this)), n && n.replaceChild(t, this));
                }, e);
            } }), re.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
            re.fn[e] = function (e) {
                for (var n, i = [], o = re(e), r = o.length - 1, s = 0; r >= s; s++) {
                    n = s === r ? this : this.clone(!0), re(o[s])[t](n), K.apply(i, n.get());
                }return this.pushStack(i);
            };
        });var Xe,
            Ye = { HTML: "block", BODY: "block" },
            Ve = /^margin/,
            Ge = new RegExp("^(" + je + ")(?!px)[a-z%]+$", "i"),
            Qe = function Qe(t) {
            var n = t.ownerDocument.defaultView;return n && n.opener || (n = e), n.getComputedStyle(t);
        },
            Je = function Je(e, t, n, i) {
            var o,
                r,
                s = {};for (r in t) {
                s[r] = e.style[r], e.style[r] = t[r];
            }o = n.apply(e, i || []);for (r in t) {
                e.style[r] = s[r];
            }return o;
        },
            Ke = G.documentElement;!function () {
            function t() {
                a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", Ke.appendChild(s);var t = e.getComputedStyle(a);n = "1%" !== t.top, r = "2px" === t.marginLeft, i = "4px" === t.width, a.style.marginRight = "50%", o = "4px" === t.marginRight, Ke.removeChild(s);
            }var n,
                i,
                o,
                r,
                s = G.createElement("div"),
                a = G.createElement("div");a.style && (a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", ie.clearCloneStyle = "content-box" === a.style.backgroundClip, s.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", s.appendChild(a), re.extend(ie, { pixelPosition: function pixelPosition() {
                    return t(), n;
                }, boxSizingReliable: function boxSizingReliable() {
                    return null == i && t(), i;
                }, pixelMarginRight: function pixelMarginRight() {
                    return null == i && t(), o;
                }, reliableMarginLeft: function reliableMarginLeft() {
                    return null == i && t(), r;
                }, reliableMarginRight: function reliableMarginRight() {
                    var t,
                        n = a.appendChild(G.createElement("div"));return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", a.style.width = "1px", Ke.appendChild(s), t = !parseFloat(e.getComputedStyle(n).marginRight), Ke.removeChild(s), a.removeChild(n), t;
                } }));
        }();var Ze = /^(none|table(?!-c[ea]).+)/,
            et = { position: "absolute", visibility: "hidden", display: "block" },
            tt = { letterSpacing: "0", fontWeight: "400" },
            nt = ["Webkit", "O", "Moz", "ms"],
            it = G.createElement("div").style;re.extend({ cssHooks: { opacity: { get: function get(e, t) {
                        if (t) {
                            var n = $(e, "opacity");return "" === n ? "1" : n;
                        }
                    } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { float: "cssFloat" }, style: function style(e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        r,
                        s,
                        a = re.camelCase(t),
                        l = e.style;return t = re.cssProps[a] || (re.cssProps[a] = A(a) || a), s = re.cssHooks[t] || re.cssHooks[a], void 0 === n ? s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : l[t] : (r = typeof n === "undefined" ? "undefined" : (0, _typeof3.default)(n), "string" === r && (o = Ne.exec(n)) && o[1] && (n = c(e, t, o), r = "number"), void (null != n && n === n && ("number" === r && (n += o && o[3] || (re.cssNumber[a] ? "" : "px")), ie.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, i)) || (l[t] = n))));
                }
            }, css: function css(e, t, n, i) {
                var o,
                    r,
                    s,
                    a = re.camelCase(t);return t = re.cssProps[a] || (re.cssProps[a] = A(a) || a), s = re.cssHooks[t] || re.cssHooks[a], s && "get" in s && (o = s.get(e, !0, n)), void 0 === o && (o = $(e, t, i)), "normal" === o && t in tt && (o = tt[t]), "" === n || n ? (r = parseFloat(o), n === !0 || isFinite(r) ? r || 0 : o) : o;
            } }), re.each(["height", "width"], function (e, t) {
            re.cssHooks[t] = { get: function get(e, n, i) {
                    return n ? Ze.test(re.css(e, "display")) && 0 === e.offsetWidth ? Je(e, et, function () {
                        return D(e, t, i);
                    }) : D(e, t, i) : void 0;
                }, set: function set(e, n, i) {
                    var o,
                        r = i && Qe(e),
                        s = i && N(e, t, i, "border-box" === re.css(e, "boxSizing", !1, r), r);return s && (o = Ne.exec(n)) && "px" !== (o[3] || "px") && (e.style[t] = n, n = re.css(e, t)), j(e, n, s);
                } };
        }), re.cssHooks.marginLeft = E(ie.reliableMarginLeft, function (e, t) {
            return t ? (parseFloat($(e, "marginLeft")) || e.getBoundingClientRect().left - Je(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
            })) + "px" : void 0;
        }), re.cssHooks.marginRight = E(ie.reliableMarginRight, function (e, t) {
            return t ? Je(e, { display: "inline-block" }, $, [e, "marginRight"]) : void 0;
        }), re.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
            re.cssHooks[e + t] = { expand: function expand(n) {
                    for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) {
                        o[e + De[i] + t] = r[i] || r[i - 2] || r[0];
                    }return o;
                } }, Ve.test(e) || (re.cssHooks[e + t].set = j);
        }), re.fn.extend({ css: function css(e, t) {
                return Te(this, function (e, t, n) {
                    var i,
                        o,
                        r = {},
                        s = 0;if (re.isArray(t)) {
                        for (i = Qe(e), o = t.length; o > s; s++) {
                            r[t[s]] = re.css(e, t[s], !1, i);
                        }return r;
                    }return void 0 !== n ? re.style(e, t, n) : re.css(e, t);
                }, e, t, arguments.length > 1);
            }, show: function show() {
                return O(this, !0);
            }, hide: function hide() {
                return O(this);
            }, toggle: function toggle(e) {
                return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
                    Oe(this) ? re(this).show() : re(this).hide();
                });
            } }), re.Tween = H, H.prototype = { constructor: H, init: function init(e, t, n, i, o, r) {
                this.elem = e, this.prop = n, this.easing = o || re.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = r || (re.cssNumber[n] ? "" : "px");
            }, cur: function cur() {
                var e = H.propHooks[this.prop];return e && e.get ? e.get(this) : H.propHooks._default.get(this);
            }, run: function run(e) {
                var t,
                    n = H.propHooks[this.prop];return this.options.duration ? this.pos = t = re.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : H.propHooks._default.set(this), this;
            } }, H.prototype.init.prototype = H.prototype, H.propHooks = { _default: { get: function get(e) {
                    var t;return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = re.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0);
                }, set: function set(e) {
                    re.fx.step[e.prop] ? re.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[re.cssProps[e.prop]] && !re.cssHooks[e.prop] ? e.elem[e.prop] = e.now : re.style(e.elem, e.prop, e.now + e.unit);
                } } }, H.propHooks.scrollTop = H.propHooks.scrollLeft = { set: function set(e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            } }, re.easing = { linear: function linear(e) {
                return e;
            }, swing: function swing(e) {
                return .5 - Math.cos(e * Math.PI) / 2;
            }, _default: "swing" }, re.fx = H.prototype.init, re.fx.step = {};var ot,
            rt,
            st = /^(?:toggle|show|hide)$/,
            at = /queueHooks$/;re.Animation = re.extend(z, { tweeners: { "*": [function (e, t) {
                    var n = this.createTween(e, t);return c(n.elem, e, Ne.exec(t), n), n;
                }] }, tweener: function tweener(e, t) {
                re.isFunction(e) ? (t = e, e = ["*"]) : e = e.match(xe);for (var n, i = 0, o = e.length; o > i; i++) {
                    n = e[i], z.tweeners[n] = z.tweeners[n] || [], z.tweeners[n].unshift(t);
                }
            }, prefilters: [I], prefilter: function prefilter(e, t) {
                t ? z.prefilters.unshift(e) : z.prefilters.push(e);
            } }), re.speed = function (e, t, n) {
            var i = e && "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) ? re.extend({}, e) : { complete: n || !n && t || re.isFunction(e) && e, duration: e, easing: n && t || t && !re.isFunction(t) && t };return i.duration = re.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in re.fx.speeds ? re.fx.speeds[i.duration] : re.fx.speeds._default, null != i.queue && i.queue !== !0 || (i.queue = "fx"), i.old = i.complete, i.complete = function () {
                re.isFunction(i.old) && i.old.call(this), i.queue && re.dequeue(this, i.queue);
            }, i;
        }, re.fn.extend({ fadeTo: function fadeTo(e, t, n, i) {
                return this.filter(Oe).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
            }, animate: function animate(e, t, n, i) {
                var o = re.isEmptyObject(e),
                    r = re.speed(t, n, i),
                    s = function s() {
                    var t = z(this, re.extend({}, e), r);(o || Se.get(this, "finish")) && t.stop(!0);
                };return s.finish = s, o || r.queue === !1 ? this.each(s) : this.queue(r.queue, s);
            }, stop: function stop(e, t, n) {
                var i = function i(e) {
                    var t = e.stop;delete e.stop, t(n);
                };return "string" != typeof e && (n = t, t = e, e = void 0), t && e !== !1 && this.queue(e || "fx", []), this.each(function () {
                    var t = !0,
                        o = null != e && e + "queueHooks",
                        r = re.timers,
                        s = Se.get(this);if (o) s[o] && s[o].stop && i(s[o]);else for (o in s) {
                        s[o] && s[o].stop && at.test(o) && i(s[o]);
                    }for (o = r.length; o--;) {
                        r[o].elem !== this || null != e && r[o].queue !== e || (r[o].anim.stop(n), t = !1, r.splice(o, 1));
                    }!t && n || re.dequeue(this, e);
                });
            }, finish: function finish(e) {
                return e !== !1 && (e = e || "fx"), this.each(function () {
                    var t,
                        n = Se.get(this),
                        i = n[e + "queue"],
                        o = n[e + "queueHooks"],
                        r = re.timers,
                        s = i ? i.length : 0;for (n.finish = !0, re.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--;) {
                        r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
                    }for (t = 0; s > t; t++) {
                        i[t] && i[t].finish && i[t].finish.call(this);
                    }delete n.finish;
                });
            } }), re.each(["toggle", "show", "hide"], function (e, t) {
            var n = re.fn[t];re.fn[t] = function (e, i, o) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(L(t, !0), e, i, o);
            };
        }), re.each({ slideDown: L("show"), slideUp: L("hide"), slideToggle: L("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
            re.fn[e] = function (e, n, i) {
                return this.animate(t, e, n, i);
            };
        }), re.timers = [], re.fx.tick = function () {
            var e,
                t = 0,
                n = re.timers;for (ot = re.now(); t < n.length; t++) {
                e = n[t], e() || n[t] !== e || n.splice(t--, 1);
            }n.length || re.fx.stop(), ot = void 0;
        }, re.fx.timer = function (e) {
            re.timers.push(e), e() ? re.fx.start() : re.timers.pop();
        }, re.fx.interval = 13, re.fx.start = function () {
            rt || (rt = e.setInterval(re.fx.tick, re.fx.interval));
        }, re.fx.stop = function () {
            e.clearInterval(rt), rt = null;
        }, re.fx.speeds = { slow: 600, fast: 200, _default: 400 }, re.fn.delay = function (t, n) {
            return t = re.fx ? re.fx.speeds[t] || t : t, n = n || "fx", this.queue(n, function (n, i) {
                var o = e.setTimeout(n, t);i.stop = function () {
                    e.clearTimeout(o);
                };
            });
        }, function () {
            var e = G.createElement("input"),
                t = G.createElement("select"),
                n = t.appendChild(G.createElement("option"));e.type = "checkbox", ie.checkOn = "" !== e.value, ie.optSelected = n.selected, t.disabled = !0, ie.optDisabled = !n.disabled, e = G.createElement("input"), e.value = "t", e.type = "radio", ie.radioValue = "t" === e.value;
        }();var lt,
            ct = re.expr.attrHandle;re.fn.extend({ attr: function attr(e, t) {
                return Te(this, re.attr, e, t, arguments.length > 1);
            }, removeAttr: function removeAttr(e) {
                return this.each(function () {
                    re.removeAttr(this, e);
                });
            } }), re.extend({ attr: function attr(e, t, n) {
                var i,
                    o,
                    r = e.nodeType;if (3 !== r && 8 !== r && 2 !== r) return "undefined" == typeof e.getAttribute ? re.prop(e, t, n) : (1 === r && re.isXMLDoc(e) || (t = t.toLowerCase(), o = re.attrHooks[t] || (re.expr.match.bool.test(t) ? lt : void 0)), void 0 !== n ? null === n ? void re.removeAttr(e, t) : o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : o && "get" in o && null !== (i = o.get(e, t)) ? i : (i = re.find.attr(e, t), null == i ? void 0 : i));
            }, attrHooks: { type: { set: function set(e, t) {
                        if (!ie.radioValue && "radio" === t && re.nodeName(e, "input")) {
                            var n = e.value;return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    } } }, removeAttr: function removeAttr(e, t) {
                var n,
                    i,
                    o = 0,
                    r = t && t.match(xe);if (r && 1 === e.nodeType) for (; n = r[o++];) {
                    i = re.propFix[n] || n, re.expr.match.bool.test(n) && (e[i] = !1), e.removeAttribute(n);
                }
            } }), lt = { set: function set(e, t, n) {
                return t === !1 ? re.removeAttr(e, n) : e.setAttribute(n, n), n;
            } }, re.each(re.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = ct[t] || re.find.attr;ct[t] = function (e, t, i) {
                var o, r;return i || (r = ct[t], ct[t] = o, o = null != n(e, t, i) ? t.toLowerCase() : null, ct[t] = r), o;
            };
        });var dt = /^(?:input|select|textarea|button)$/i,
            ut = /^(?:a|area)$/i;re.fn.extend({ prop: function prop(e, t) {
                return Te(this, re.prop, e, t, arguments.length > 1);
            }, removeProp: function removeProp(e) {
                return this.each(function () {
                    delete this[re.propFix[e] || e];
                });
            } }), re.extend({ prop: function prop(e, t, n) {
                var i,
                    o,
                    r = e.nodeType;if (3 !== r && 8 !== r && 2 !== r) return 1 === r && re.isXMLDoc(e) || (t = re.propFix[t] || t, o = re.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : e[t] = n : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t];
            }, propHooks: { tabIndex: { get: function get(e) {
                        var t = re.find.attr(e, "tabindex");return t ? parseInt(t, 10) : dt.test(e.nodeName) || ut.test(e.nodeName) && e.href ? 0 : -1;
                    } } }, propFix: { for: "htmlFor", class: "className" } }), ie.optSelected || (re.propHooks.selected = { get: function get(e) {
                var t = e.parentNode;return t && t.parentNode && t.parentNode.selectedIndex, null;
            }, set: function set(e) {
                var t = e.parentNode;t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
            } }), re.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            re.propFix[this.toLowerCase()] = this;
        });var pt = /[\t\r\n\f]/g;re.fn.extend({ addClass: function addClass(e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;if (re.isFunction(e)) return this.each(function (t) {
                    re(this).addClass(e.call(this, t, _(this)));
                });if ("string" == typeof e && e) for (t = e.match(xe) || []; n = this[l++];) {
                    if (o = _(n), i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")) {
                        for (s = 0; r = t[s++];) {
                            i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                        }a = re.trim(i), o !== a && n.setAttribute("class", a);
                    }
                }return this;
            }, removeClass: function removeClass(e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;if (re.isFunction(e)) return this.each(function (t) {
                    re(this).removeClass(e.call(this, t, _(this)));
                });if (!arguments.length) return this.attr("class", "");if ("string" == typeof e && e) for (t = e.match(xe) || []; n = this[l++];) {
                    if (o = _(n), i = 1 === n.nodeType && (" " + o + " ").replace(pt, " ")) {
                        for (s = 0; r = t[s++];) {
                            for (; i.indexOf(" " + r + " ") > -1;) {
                                i = i.replace(" " + r + " ", " ");
                            }
                        }a = re.trim(i), o !== a && n.setAttribute("class", a);
                    }
                }return this;
            }, toggleClass: function toggleClass(e, t) {
                var n = typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e);return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : re.isFunction(e) ? this.each(function (n) {
                    re(this).toggleClass(e.call(this, n, _(this), t), t);
                }) : this.each(function () {
                    var t, i, o, r;if ("string" === n) for (i = 0, o = re(this), r = e.match(xe) || []; t = r[i++];) {
                        o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                    } else void 0 !== e && "boolean" !== n || (t = _(this), t && Se.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || e === !1 ? "" : Se.get(this, "__className__") || ""));
                });
            }, hasClass: function hasClass(e) {
                var t,
                    n,
                    i = 0;for (t = " " + e + " "; n = this[i++];) {
                    if (1 === n.nodeType && (" " + _(n) + " ").replace(pt, " ").indexOf(t) > -1) return !0;
                }return !1;
            } });var ft = /\r/g,
            ht = /[\x20\t\r\n\f]+/g;re.fn.extend({ val: function val(e) {
                var t,
                    n,
                    i,
                    o = this[0];return arguments.length ? (i = re.isFunction(e), this.each(function (n) {
                    var o;1 === this.nodeType && (o = i ? e.call(this, n, re(this).val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : re.isArray(o) && (o = re.map(o, function (e) {
                        return null == e ? "" : e + "";
                    })), t = re.valHooks[this.type] || re.valHooks[this.nodeName.toLowerCase()], t && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o));
                })) : o ? (t = re.valHooks[o.type] || re.valHooks[o.nodeName.toLowerCase()], t && "get" in t && void 0 !== (n = t.get(o, "value")) ? n : (n = o.value, "string" == typeof n ? n.replace(ft, "") : null == n ? "" : n)) : void 0;
            } }), re.extend({ valHooks: { option: { get: function get(e) {
                        var t = re.find.attr(e, "value");return null != t ? t : re.trim(re.text(e)).replace(ht, " ");
                    } }, select: { get: function get(e) {
                        for (var t, n, i = e.options, o = e.selectedIndex, r = "select-one" === e.type || 0 > o, s = r ? null : [], a = r ? o + 1 : i.length, l = 0 > o ? a : r ? o : 0; a > l; l++) {
                            if (n = i[l], (n.selected || l === o) && (ie.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !re.nodeName(n.parentNode, "optgroup"))) {
                                if (t = re(n).val(), r) return t;s.push(t);
                            }
                        }return s;
                    }, set: function set(e, t) {
                        for (var n, i, o = e.options, r = re.makeArray(t), s = o.length; s--;) {
                            i = o[s], (i.selected = re.inArray(re.valHooks.option.get(i), r) > -1) && (n = !0);
                        }return n || (e.selectedIndex = -1), r;
                    } } } }), re.each(["radio", "checkbox"], function () {
            re.valHooks[this] = { set: function set(e, t) {
                    return re.isArray(t) ? e.checked = re.inArray(re(e).val(), t) > -1 : void 0;
                } }, ie.checkOn || (re.valHooks[this].get = function (e) {
                return null === e.getAttribute("value") ? "on" : e.value;
            });
        });var gt = /^(?:focusinfocus|focusoutblur)$/;re.extend(re.event, { trigger: function trigger(t, n, i, o) {
                var r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p = [i || G],
                    f = ne.call(t, "type") ? t.type : t,
                    h = ne.call(t, "namespace") ? t.namespace.split(".") : [];if (s = a = i = i || G, 3 !== i.nodeType && 8 !== i.nodeType && !gt.test(f + re.event.triggered) && (f.indexOf(".") > -1 && (h = f.split("."), f = h.shift(), h.sort()), c = f.indexOf(":") < 0 && "on" + f, t = t[re.expando] ? t : new re.Event(f, "object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && t), t.isTrigger = o ? 2 : 3, t.namespace = h.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : re.makeArray(n, [t]), u = re.event.special[f] || {}, o || !u.trigger || u.trigger.apply(i, n) !== !1)) {
                    if (!o && !u.noBubble && !re.isWindow(i)) {
                        for (l = u.delegateType || f, gt.test(l + f) || (s = s.parentNode); s; s = s.parentNode) {
                            p.push(s), a = s;
                        }a === (i.ownerDocument || G) && p.push(a.defaultView || a.parentWindow || e);
                    }for (r = 0; (s = p[r++]) && !t.isPropagationStopped();) {
                        t.type = r > 1 ? l : u.bindType || f, d = (Se.get(s, "events") || {})[t.type] && Se.get(s, "handle"), d && d.apply(s, n), d = c && s[c], d && d.apply && Ce(s) && (t.result = d.apply(s, n), t.result === !1 && t.preventDefault());
                    }return t.type = f, o || t.isDefaultPrevented() || u._default && u._default.apply(p.pop(), n) !== !1 || !Ce(i) || c && re.isFunction(i[f]) && !re.isWindow(i) && (a = i[c], a && (i[c] = null), re.event.triggered = f, i[f](), re.event.triggered = void 0, a && (i[c] = a)), t.result;
                }
            }, simulate: function simulate(e, t, n) {
                var i = re.extend(new re.Event(), n, { type: e, isSimulated: !0 });re.event.trigger(i, null, t), i.isDefaultPrevented() && n.preventDefault();
            } }), re.fn.extend({ trigger: function trigger(e, t) {
                return this.each(function () {
                    re.event.trigger(e, t, this);
                });
            }, triggerHandler: function triggerHandler(e, t) {
                var n = this[0];return n ? re.event.trigger(e, t, n, !0) : void 0;
            } }), re.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
            re.fn[t] = function (e, n) {
                return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
            };
        }), re.fn.extend({ hover: function hover(e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            } }), ie.focusin = "onfocusin" in e, ie.focusin || re.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            var n = function n(e) {
                re.event.simulate(t, e.target, re.event.fix(e));
            };re.event.special[t] = { setup: function setup() {
                    var i = this.ownerDocument || this,
                        o = Se.access(i, t);o || i.addEventListener(e, n, !0), Se.access(i, t, (o || 0) + 1);
                }, teardown: function teardown() {
                    var i = this.ownerDocument || this,
                        o = Se.access(i, t) - 1;o ? Se.access(i, t, o) : (i.removeEventListener(e, n, !0), Se.remove(i, t));
                } };
        });var vt = e.location,
            mt = re.now(),
            yt = /\?/;re.parseJSON = function (e) {
            return JSON.parse(e + "");
        }, re.parseXML = function (t) {
            var n;if (!t || "string" != typeof t) return null;try {
                n = new e.DOMParser().parseFromString(t, "text/xml");
            } catch (e) {
                n = void 0;
            }return n && !n.getElementsByTagName("parsererror").length || re.error("Invalid XML: " + t), n;
        };var wt = /#.*$/,
            bt = /([?&])_=[^&]*/,
            xt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            kt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            Tt = /^(?:GET|HEAD)$/,
            Ct = /^\/\//,
            St = {},
            $t = {},
            Et = "*/".concat("*"),
            At = G.createElement("a");At.href = vt.href, re.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: vt.href, type: "GET", isLocal: kt.test(vt.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Et, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": re.parseJSON, "text xml": re.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(e, t) {
                return t ? W(W(e, re.ajaxSettings), t) : W(re.ajaxSettings, e);
            }, ajaxPrefilter: F(St), ajaxTransport: F($t), ajax: function ajax(t, n) {
                function i(t, n, i, a) {
                    var c,
                        u,
                        y,
                        w,
                        x,
                        T = n;2 !== b && (b = 2, l && e.clearTimeout(l), o = void 0, s = a || "", k.readyState = t > 0 ? 4 : 0, c = t >= 200 && 300 > t || 304 === t, i && (w = B(p, k, i)), w = U(p, w, k, c), c ? (p.ifModified && (x = k.getResponseHeader("Last-Modified"), x && (re.lastModified[r] = x), x = k.getResponseHeader("etag"), x && (re.etag[r] = x)), 204 === t || "HEAD" === p.type ? T = "nocontent" : 304 === t ? T = "notmodified" : (T = w.state, u = w.data, y = w.error, c = !y)) : (y = T, !t && T || (T = "error", 0 > t && (t = 0))), k.status = t, k.statusText = (n || T) + "", c ? g.resolveWith(f, [u, T, k]) : g.rejectWith(f, [k, T, y]), k.statusCode(m), m = void 0, d && h.trigger(c ? "ajaxSuccess" : "ajaxError", [k, p, c ? u : y]), v.fireWith(f, [k, T]), d && (h.trigger("ajaxComplete", [k, p]), --re.active || re.event.trigger("ajaxStop")));
                }"object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && (n = t, t = void 0), n = n || {};var o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    d,
                    u,
                    p = re.ajaxSetup({}, n),
                    f = p.context || p,
                    h = p.context && (f.nodeType || f.jquery) ? re(f) : re.event,
                    g = re.Deferred(),
                    v = re.Callbacks("once memory"),
                    m = p.statusCode || {},
                    y = {},
                    w = {},
                    b = 0,
                    x = "canceled",
                    k = { readyState: 0, getResponseHeader: function getResponseHeader(e) {
                        var t;if (2 === b) {
                            if (!a) for (a = {}; t = xt.exec(s);) {
                                a[t[1].toLowerCase()] = t[2];
                            }t = a[e.toLowerCase()];
                        }return null == t ? null : t;
                    }, getAllResponseHeaders: function getAllResponseHeaders() {
                        return 2 === b ? s : null;
                    }, setRequestHeader: function setRequestHeader(e, t) {
                        var n = e.toLowerCase();return b || (e = w[n] = w[n] || e, y[e] = t), this;
                    }, overrideMimeType: function overrideMimeType(e) {
                        return b || (p.mimeType = e), this;
                    }, statusCode: function statusCode(e) {
                        var t;if (e) if (2 > b) for (t in e) {
                            m[t] = [m[t], e[t]];
                        } else k.always(e[k.status]);return this;
                    }, abort: function abort(e) {
                        var t = e || x;return o && o.abort(t), i(0, t), this;
                    } };if (g.promise(k).complete = v.add, k.success = k.done, k.error = k.fail, p.url = ((t || p.url || vt.href) + "").replace(wt, "").replace(Ct, vt.protocol + "//"), p.type = n.method || n.type || p.method || p.type, p.dataTypes = re.trim(p.dataType || "*").toLowerCase().match(xe) || [""], null == p.crossDomain) {
                    c = G.createElement("a");try {
                        c.href = p.url, c.href = c.href, p.crossDomain = At.protocol + "//" + At.host != c.protocol + "//" + c.host;
                    } catch (e) {
                        p.crossDomain = !0;
                    }
                }if (p.data && p.processData && "string" != typeof p.data && (p.data = re.param(p.data, p.traditional)), R(St, p, n, k), 2 === b) return k;d = re.event && p.global, d && 0 === re.active++ && re.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !Tt.test(p.type), r = p.url, p.hasContent || (p.data && (r = p.url += (yt.test(r) ? "&" : "?") + p.data, delete p.data), p.cache === !1 && (p.url = bt.test(r) ? r.replace(bt, "$1_=" + mt++) : r + (yt.test(r) ? "&" : "?") + "_=" + mt++)), p.ifModified && (re.lastModified[r] && k.setRequestHeader("If-Modified-Since", re.lastModified[r]), re.etag[r] && k.setRequestHeader("If-None-Match", re.etag[r])), (p.data && p.hasContent && p.contentType !== !1 || n.contentType) && k.setRequestHeader("Content-Type", p.contentType), k.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Et + "; q=0.01" : "") : p.accepts["*"]);for (u in p.headers) {
                    k.setRequestHeader(u, p.headers[u]);
                }if (p.beforeSend && (p.beforeSend.call(f, k, p) === !1 || 2 === b)) return k.abort();x = "abort";for (u in { success: 1, error: 1, complete: 1 }) {
                    k[u](p[u]);
                }if (o = R($t, p, n, k)) {
                    if (k.readyState = 1, d && h.trigger("ajaxSend", [k, p]), 2 === b) return k;p.async && p.timeout > 0 && (l = e.setTimeout(function () {
                        k.abort("timeout");
                    }, p.timeout));try {
                        b = 1, o.send(y, i);
                    } catch (e) {
                        if (!(2 > b)) throw e;i(-1, e);
                    }
                } else i(-1, "No Transport");return k;
            }, getJSON: function getJSON(e, t, n) {
                return re.get(e, t, n, "json");
            }, getScript: function getScript(e, t) {
                return re.get(e, void 0, t, "script");
            } }), re.each(["get", "post"], function (e, t) {
            re[t] = function (e, n, i, o) {
                return re.isFunction(n) && (o = o || i, i = n, n = void 0), re.ajax(re.extend({ url: e, type: t, dataType: o, data: n, success: i }, re.isPlainObject(e) && e));
            };
        }), re._evalUrl = function (e) {
            return re.ajax({ url: e, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 });
        }, re.fn.extend({ wrapAll: function wrapAll(e) {
                var t;return re.isFunction(e) ? this.each(function (t) {
                    re(this).wrapAll(e.call(this, t));
                }) : (this[0] && (t = re(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
                    for (var e = this; e.firstElementChild;) {
                        e = e.firstElementChild;
                    }return e;
                }).append(this)), this);
            }, wrapInner: function wrapInner(e) {
                return re.isFunction(e) ? this.each(function (t) {
                    re(this).wrapInner(e.call(this, t));
                }) : this.each(function () {
                    var t = re(this),
                        n = t.contents();n.length ? n.wrapAll(e) : t.append(e);
                });
            }, wrap: function wrap(e) {
                var t = re.isFunction(e);return this.each(function (n) {
                    re(this).wrapAll(t ? e.call(this, n) : e);
                });
            }, unwrap: function unwrap() {
                return this.parent().each(function () {
                    re.nodeName(this, "body") || re(this).replaceWith(this.childNodes);
                }).end();
            } }), re.expr.filters.hidden = function (e) {
            return !re.expr.filters.visible(e);
        }, re.expr.filters.visible = function (e) {
            return e.offsetWidth > 0 || e.offsetHeight > 0 || e.getClientRects().length > 0;
        };var jt = /%20/g,
            Nt = /\[\]$/,
            Dt = /\r?\n/g,
            Ot = /^(?:submit|button|image|reset|file)$/i,
            Ht = /^(?:input|select|textarea|keygen)/i;re.param = function (e, t) {
            var n,
                i = [],
                o = function o(e, t) {
                t = re.isFunction(t) ? t() : null == t ? "" : t, i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t);
            };if (void 0 === t && (t = re.ajaxSettings && re.ajaxSettings.traditional), re.isArray(e) || e.jquery && !re.isPlainObject(e)) re.each(e, function () {
                o(this.name, this.value);
            });else for (n in e) {
                X(n, e[n], t, o);
            }return i.join("&").replace(jt, "+");
        }, re.fn.extend({ serialize: function serialize() {
                return re.param(this.serializeArray());
            }, serializeArray: function serializeArray() {
                return this.map(function () {
                    var e = re.prop(this, "elements");return e ? re.makeArray(e) : this;
                }).filter(function () {
                    var e = this.type;return this.name && !re(this).is(":disabled") && Ht.test(this.nodeName) && !Ot.test(e) && (this.checked || !He.test(e));
                }).map(function (e, t) {
                    var n = re(this).val();return null == n ? null : re.isArray(n) ? re.map(n, function (e) {
                        return { name: t.name, value: e.replace(Dt, "\r\n") };
                    }) : { name: t.name, value: n.replace(Dt, "\r\n") };
                }).get();
            } }), re.ajaxSettings.xhr = function () {
            try {
                return new e.XMLHttpRequest();
            } catch (e) {}
        };var Pt = { 0: 200, 1223: 204 },
            Lt = re.ajaxSettings.xhr();ie.cors = !!Lt && "withCredentials" in Lt, ie.ajax = Lt = !!Lt, re.ajaxTransport(function (t) {
            var _n, i;return ie.cors || Lt && !t.crossDomain ? { send: function send(o, r) {
                    var s,
                        a = t.xhr();if (a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields) for (s in t.xhrFields) {
                        a[s] = t.xhrFields[s];
                    }t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest");for (s in o) {
                        a.setRequestHeader(s, o[s]);
                    }_n = function n(e) {
                        return function () {
                            _n && (_n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? r(0, "error") : r(a.status, a.statusText) : r(Pt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText }, a.getAllResponseHeaders()));
                        };
                    }, a.onload = _n(), i = a.onerror = _n("error"), void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function () {
                        4 === a.readyState && e.setTimeout(function () {
                            _n && i();
                        });
                    }, _n = _n("abort");try {
                        a.send(t.hasContent && t.data || null);
                    } catch (e) {
                        if (_n) throw e;
                    }
                }, abort: function abort() {
                    _n && _n();
                } } : void 0;
        }), re.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function textScript(e) {
                    return re.globalEval(e), e;
                } } }), re.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }), re.ajaxTransport("script", function (e) {
            if (e.crossDomain) {
                var t, _n2;return { send: function send(i, o) {
                        t = re("<script>").prop({ charset: e.scriptCharset, src: e.url }).on("load error", _n2 = function n(e) {
                            t.remove(), _n2 = null, e && o("error" === e.type ? 404 : 200, e.type);
                        }), G.head.appendChild(t[0]);
                    }, abort: function abort() {
                        _n2 && _n2();
                    } };
            }
        });var qt = [],
            It = /(=)\?(?=&|$)|\?\?/;re.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
                var e = qt.pop() || re.expando + "_" + mt++;return this[e] = !0, e;
            } }), re.ajaxPrefilter("json jsonp", function (t, n, i) {
            var o,
                r,
                s,
                a = t.jsonp !== !1 && (It.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && It.test(t.data) && "data");return a || "jsonp" === t.dataTypes[0] ? (o = t.jsonpCallback = re.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, a ? t[a] = t[a].replace(It, "$1" + o) : t.jsonp !== !1 && (t.url += (yt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o), t.converters["script json"] = function () {
                return s || re.error(o + " was not called"), s[0];
            }, t.dataTypes[0] = "json", r = e[o], e[o] = function () {
                s = arguments;
            }, i.always(function () {
                void 0 === r ? re(e).removeProp(o) : e[o] = r, t[o] && (t.jsonpCallback = n.jsonpCallback, qt.push(o)), s && re.isFunction(r) && r(s[0]), s = r = void 0;
            }), "script") : void 0;
        }), re.parseHTML = function (e, t, n) {
            if (!e || "string" != typeof e) return null;"boolean" == typeof t && (n = t, t = !1), t = t || G;var i = he.exec(e),
                o = !n && [];return i ? [t.createElement(i[1])] : (i = p([e], t, o), o && o.length && re(o).remove(), re.merge([], i.childNodes));
        };var Mt = re.fn.load;re.fn.load = function (e, t, n) {
            if ("string" != typeof e && Mt) return Mt.apply(this, arguments);var i,
                o,
                r,
                s = this,
                a = e.indexOf(" ");return a > -1 && (i = re.trim(e.slice(a)), e = e.slice(0, a)), re.isFunction(t) ? (n = t, t = void 0) : t && "object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) && (o = "POST"), s.length > 0 && re.ajax({ url: e, type: o || "GET", dataType: "html", data: t }).done(function (e) {
                r = arguments, s.html(i ? re("<div>").append(re.parseHTML(e)).find(i) : e);
            }).always(n && function (e, t) {
                s.each(function () {
                    n.apply(this, r || [e.responseText, t, e]);
                });
            }), this;
        }, re.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            re.fn[t] = function (e) {
                return this.on(t, e);
            };
        }), re.expr.filters.animated = function (e) {
            return re.grep(re.timers, function (t) {
                return e === t.elem;
            }).length;
        }, re.offset = { setOffset: function setOffset(e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    d = re.css(e, "position"),
                    u = re(e),
                    p = {};"static" === d && (e.style.position = "relative"), a = u.offset(), r = re.css(e, "top"), l = re.css(e, "left"), c = ("absolute" === d || "fixed" === d) && (r + l).indexOf("auto") > -1, c ? (i = u.position(), s = i.top, o = i.left) : (s = parseFloat(r) || 0, o = parseFloat(l) || 0), re.isFunction(t) && (t = t.call(e, n, re.extend({}, a))), null != t.top && (p.top = t.top - a.top + s), null != t.left && (p.left = t.left - a.left + o), "using" in t ? t.using.call(e, p) : u.css(p);
            } }, re.fn.extend({ offset: function offset(e) {
                if (arguments.length) return void 0 === e ? this : this.each(function (t) {
                    re.offset.setOffset(this, e, t);
                });var t,
                    n,
                    i = this[0],
                    o = { top: 0, left: 0 },
                    r = i && i.ownerDocument;return r ? (t = r.documentElement, re.contains(t, i) ? (o = i.getBoundingClientRect(), n = Y(r), { top: o.top + n.pageYOffset - t.clientTop, left: o.left + n.pageXOffset - t.clientLeft }) : o) : void 0;
            }, position: function position() {
                if (this[0]) {
                    var e,
                        t,
                        n = this[0],
                        i = { top: 0, left: 0 };return "fixed" === re.css(n, "position") ? t = n.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), re.nodeName(e[0], "html") || (i = e.offset()), i.top += re.css(e[0], "borderTopWidth", !0), i.left += re.css(e[0], "borderLeftWidth", !0)), { top: t.top - i.top - re.css(n, "marginTop", !0), left: t.left - i.left - re.css(n, "marginLeft", !0) };
                }
            }, offsetParent: function offsetParent() {
                return this.map(function () {
                    for (var e = this.offsetParent; e && "static" === re.css(e, "position");) {
                        e = e.offsetParent;
                    }return e || Ke;
                });
            } }), re.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
            var n = "pageYOffset" === t;re.fn[e] = function (i) {
                return Te(this, function (e, i, o) {
                    var r = Y(e);return void 0 === o ? r ? r[t] : e[i] : void (r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : e[i] = o);
                }, e, i, arguments.length);
            };
        }), re.each(["top", "left"], function (e, t) {
            re.cssHooks[t] = E(ie.pixelPosition, function (e, n) {
                return n ? (n = $(e, t), Ge.test(n) ? re(e).position()[t] + "px" : n) : void 0;
            });
        }), re.each({ Height: "height", Width: "width" }, function (e, t) {
            re.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                re.fn[i] = function (i, o) {
                    var r = arguments.length && (n || "boolean" != typeof i),
                        s = n || (i === !0 || o === !0 ? "margin" : "border");return Te(this, function (t, n, i) {
                        var o;return re.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? re.css(t, n, s) : re.style(t, n, i, s);
                    }, t, r ? i : void 0, r, null);
                };
            });
        }), re.fn.extend({ bind: function bind(e, t, n) {
                return this.on(e, null, t, n);
            }, unbind: function unbind(e, t) {
                return this.off(e, null, t);
            }, delegate: function delegate(e, t, n, i) {
                return this.on(t, e, n, i);
            }, undelegate: function undelegate(e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            }, size: function size() {
                return this.length;
            } }), re.fn.andSelf = re.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function () {
            return re;
        });var zt = e.jQuery,
            _t = e.$;return re.noConflict = function (t) {
            return e.$ === re && (e.$ = _t), t && e.jQuery === re && (e.jQuery = zt), re;
        }, t || (e.jQuery = e.$ = re), re;
    }), /*!
        * jQuery Cookie Plugin v1.4.1
        * https://github.com/carhartl/jquery-cookie
        *
        * Copyright 2006, 2014 Klaus Hartl
        * Released under the MIT license
        */
    !function (e) {
        "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? require("jquery") : jQuery);
    }(function (e) {
        function t(e) {
            return a.raw ? e : encodeURIComponent(e);
        }function n(e) {
            return a.raw ? e : decodeURIComponent(e);
        }function i(e) {
            return t(a.json ? JSON.stringify(e) : String(e));
        }function o(e) {
            0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));try {
                return e = decodeURIComponent(e.replace(s, " ")), a.json ? JSON.parse(e) : e;
            } catch (e) {}
        }function r(t, n) {
            var i = a.raw ? t : o(t);return e.isFunction(n) ? n(i) : i;
        }var s = /\+/g,
            a = e.cookie = function (o, s, l) {
            if (arguments.length > 1 && !e.isFunction(s)) {
                if (l = e.extend({}, a.defaults, l), "number" == typeof l.expires) {
                    var c = l.expires,
                        d = l.expires = new Date();d.setTime(+d + 864e5 * c);
                }return document.cookie = [t(o), "=", i(s), l.expires ? "; expires=" + l.expires.toUTCString() : "", l.path ? "; path=" + l.path : "", l.domain ? "; domain=" + l.domain : "", l.secure ? "; secure" : ""].join("");
            }for (var u = o ? void 0 : {}, p = document.cookie ? document.cookie.split("; ") : [], f = 0, h = p.length; h > f; f++) {
                var g = p[f].split("="),
                    v = n(g.shift()),
                    m = g.join("=");if (o && o === v) {
                    u = r(m, s);break;
                }o || void 0 === (m = r(m)) || (u[v] = m);
            }return u;
        };a.defaults = {}, e.removeCookie = function (t, n) {
            return void 0 !== e.cookie(t) && (e.cookie(t, "", e.extend({}, n, { expires: -1 })), !e.cookie(t));
        };
    }), /*!
        * CoverPop 2.5.1
        * http://coverpopjs.com
        *
        * Copyright (c) 2015 Tyler Pearson
        * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
        */
    !function (e) {
        "use strict";
        var t = { coverId: "CoverPop-cover", expires: 30, closeClassNoDefault: "CoverPop-close", closeClassDefault: "CoverPop-close-go", openClassDefault: "CoverPop-open", cookieName: "_CoverPop", onPopUpOpen: null, onPopUpClose: null, forceHash: "splash", delayHash: "go", closeOnEscape: !0, delay: 0, hideAfter: null },
            n = {},
            i = { hasClass: function hasClass(e, t) {
                return new RegExp("(\\s|^)" + t + "(\\s|$)").test(e.className);
            }, addClass: function addClass(e, t) {
                i.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
            }, removeClass: function removeClass(e, t) {
                i.hasClass(e, t) && (e.className = e.className.replace(new RegExp("(\\s|^)" + t + "(\\s|$)"), " ").replace(/^\s+|\s+$/g, ""));
            }, addListener: function addListener(e, t, n) {
                e.addEventListener ? e.addEventListener(t, n, !1) : e.attachEvent && e.attachEvent("on" + t, n);
            }, removeListener: function removeListener(e, t, n) {
                e.removeEventListener ? e.removeEventListener(t, n, !1) : e.detachEvent && e.detachEvent("on" + t, n);
            }, isFunction: function isFunction(e) {
                var t = {};return e && "[object Function]" === t.toString.call(e);
            }, setCookie: function setCookie(e, t) {
                var n = new Date();n.setTime(+n + 864e5 * t), document.cookie = e + "=true; expires=" + n.toGMTString() + "; path=/";
            }, hasCookie: function hasCookie(e) {
                return -1 !== document.cookie.indexOf(e);
            }, hashExists: function hashExists(e) {
                return -1 !== window.location.hash.indexOf(e);
            }, preventDefault: function preventDefault(e) {
                e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            }, mergeObj: function mergeObj(e, t) {
                for (var n in t) {
                    e[n] = t[n];
                }
            } },
            o = function o(n) {
            t.closeOnEscape && 27 === n.keyCode && e.close();
        },
            r = function r() {
            if (null !== t.onPopUpOpen) {
                if (!i.isFunction(t.onPopUpOpen)) throw new TypeError("CoverPop open callback must be a function.");t.onPopUpOpen.call();
            }
        },
            s = function s() {
            if (null !== t.onPopUpClose) {
                if (!i.isFunction(t.onPopUpClose)) throw new TypeError("CoverPop close callback must be a function.");t.onPopUpClose.call();
            }
        };e.open = function () {
            var s, a;if (i.hashExists(t.delayHash)) return void i.setCookie(t.cookieName, 1);if (i.addClass(n.html, t.openClassDefault), n.closeClassNoDefaultEls.length > 0) for (s = 0, a = n.closeClassNoDefaultEls.length; a > s; s++) {
                i.addListener(n.closeClassNoDefaultEls[s], "click", function (t) {
                    t.target === this && (i.preventDefault(t), e.close());
                });
            }if (n.closeClassDefaultEls.length > 0) for (s = 0, a = n.closeClassDefaultEls.length; a > s; s++) {
                i.addListener(n.closeClassDefaultEls[s], "click", function (t) {
                    t.target === this && e.close();
                });
            }i.addListener(document, "keyup", o), r();
        }, e.close = function () {
            i.removeClass(n.html, t.openClassDefault), i.setCookie(t.cookieName, t.expires), i.removeListener(document, "keyup", o), s();
        }, e.init = function (o) {
            navigator.cookieEnabled && (i.mergeObj(t, o), n = { html: document.getElementsByTagName("html")[0], cover: document.getElementById(t.coverId), closeClassDefaultEls: document.querySelectorAll("." + t.closeClassDefault), closeClassNoDefaultEls: document.querySelectorAll("." + t.closeClassNoDefault) }, (!i.hasCookie(t.cookieName) || i.hashExists(t.forceHash)) && (0 === t.delay ? e.open() : setTimeout(e.open, t.delay), t.hideAfter && setTimeout(e.close, t.hideAfter + t.delay)));
        }, e.start = function (t) {
            e.init(t);
        };
    }(window.CoverPop = window.CoverPop || {}), /*!
                                                * https://github.com/scdoshi/jquery-ajaxchimp
                                                */
    function (e) {
        "use strict";
        e.ajaxChimp = { responses: { "We have sent you a confirmation email": 0, "Please enter a value": 1, "An email address must contain a single @": 2, "The domain portion of the email address is invalid (the portion after the @: )": 3, "The username portion of the email address is invalid (the portion before the @: )": 4, "This email address looks fake or invalid. Please enter a real email address": 5 }, translations: { en: null }, init: function init(t, n) {
                e(t).ajaxChimp(n);
            } }, e.fn.ajaxChimp = function (t) {
            return e(this).each(function (n, i) {
                var o = e(i),
                    r = o.find("input[type=email]"),
                    s = o.find("label[for=" + r.attr("id") + "]"),
                    a = e.extend({ url: o.attr("action"), language: "en" }, t),
                    l = a.url.replace("/post?", "/post-json?").concat("&c=?");o.attr("novalidate", "true"), r.attr("name", "EMAIL"), o.submit(function () {
                    function t(t) {
                        if ("success" === t.result) n = "We have sent you a confirmation email", s.removeClass("error").addClass("valid"), r.removeClass("error").addClass("valid");else {
                            r.removeClass("valid").addClass("error"), s.removeClass("valid").addClass("error");var i = -1;try {
                                var o = t.msg.split(" - ", 2);if (void 0 === o[1]) n = t.msg;else {
                                    var l = parseInt(o[0], 10);l.toString() === o[0] ? (i = o[0], n = o[1]) : (i = -1, n = t.msg);
                                }
                            } catch (e) {
                                i = -1, n = t.msg;
                            }
                        }"en" !== a.language && void 0 !== e.ajaxChimp.responses[n] && e.ajaxChimp.translations && e.ajaxChimp.translations[a.language] && e.ajaxChimp.translations[a.language][e.ajaxChimp.responses[n]] && (n = e.ajaxChimp.translations[a.language][e.ajaxChimp.responses[n]]), s.html(n), s.show(2e3), a.callback && a.callback(t);
                    }var n,
                        i = {},
                        c = o.serializeArray();e.each(c, function (e, t) {
                        i[t.name] = t.value;
                    }), e.ajax({ url: l, data: i, success: t, dataType: "jsonp", error: function error(e, t) {
                            console.log("mailchimp ajax submit error: " + t);
                        } });var d = "Submitting...";return "en" !== a.language && e.ajaxChimp.translations && e.ajaxChimp.translations[a.language] && e.ajaxChimp.translations[a.language].submit && (d = e.ajaxChimp.translations[a.language].submit), s.html(d).show(2e3), !1;
                });
            }), this;
        };
    }(jQuery), function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof module && module.exports ? module.exports = e(require("jquery")) : e(jQuery);
    }(function (e) {
        var t = -1,
            n = -1,
            i = function i(e) {
            return parseFloat(e) || 0;
        },
            o = function o(t) {
            var n = 1,
                o = e(t),
                r = null,
                s = [];return o.each(function () {
                var t = e(this),
                    o = t.offset().top - i(t.css("margin-top")),
                    a = s.length > 0 ? s[s.length - 1] : null;null === a ? s.push(t) : Math.floor(Math.abs(r - o)) <= n ? s[s.length - 1] = a.add(t) : s.push(t), r = o;
            }), s;
        },
            r = function r(t) {
            var n = { byRow: !0, property: "height", target: null, remove: !1 };return "object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) ? e.extend(n, t) : ("boolean" == typeof t ? n.byRow = t : "remove" === t && (n.remove = !0), n);
        },
            s = e.fn.matchHeight = function (t) {
            var n = r(t);if (n.remove) {
                var i = this;return this.css(n.property, ""), e.each(s._groups, function (e, t) {
                    t.elements = t.elements.not(i);
                }), this;
            }return this.length <= 1 && !n.target ? this : (s._groups.push({ elements: this, options: n }), s._apply(this, n), this);
        };s.version = "master", s._groups = [], s._throttle = 80, s._maintainScroll = !1, s._beforeUpdate = null, s._afterUpdate = null, s._rows = o, s._parse = i, s._parseOptions = r, s._apply = function (t, n) {
            var a = r(n),
                l = e(t),
                c = [l],
                d = e(window).scrollTop(),
                u = e("html").outerHeight(!0),
                p = l.parents().filter(":hidden");return p.each(function () {
                var t = e(this);t.data("style-cache", t.attr("style"));
            }), p.css("display", "block"), a.byRow && !a.target && (l.each(function () {
                var t = e(this),
                    n = t.css("display");"inline-block" !== n && "flex" !== n && "inline-flex" !== n && (n = "block"), t.data("style-cache", t.attr("style")), t.css({ display: n, "padding-top": "0", "padding-bottom": "0", "margin-top": "0", "margin-bottom": "0", "border-top-width": "0", "border-bottom-width": "0", height: "100px", overflow: "hidden" });
            }), c = o(l), l.each(function () {
                var t = e(this);t.attr("style", t.data("style-cache") || "");
            })), e.each(c, function (t, n) {
                var o = e(n),
                    r = 0;if (a.target) r = a.target.outerHeight(!1);else {
                    if (a.byRow && o.length <= 1) return void o.css(a.property, "");o.each(function () {
                        var t = e(this),
                            n = t.attr("style"),
                            i = t.css("display");"inline-block" !== i && "flex" !== i && "inline-flex" !== i && (i = "block");var o = { display: i };o[a.property] = "", t.css(o), t.outerHeight(!1) > r && (r = t.outerHeight(!1)), n ? t.attr("style", n) : t.css("display", "");
                    });
                }o.each(function () {
                    var t = e(this),
                        n = 0;a.target && t.is(a.target) || ("border-box" !== t.css("box-sizing") && (n += i(t.css("border-top-width")) + i(t.css("border-bottom-width")), n += i(t.css("padding-top")) + i(t.css("padding-bottom"))), t.css(a.property, r - n + "px"));
                });
            }), p.each(function () {
                var t = e(this);t.attr("style", t.data("style-cache") || null);
            }), s._maintainScroll && e(window).scrollTop(d / u * e("html").outerHeight(!0)), this;
        }, s._applyDataApi = function () {
            var t = {};e("[data-match-height], [data-mh]").each(function () {
                var n = e(this),
                    i = n.attr("data-mh") || n.attr("data-match-height");i in t ? t[i] = t[i].add(n) : t[i] = n;
            }), e.each(t, function () {
                this.matchHeight(!0);
            });
        };var a = function a(t) {
            s._beforeUpdate && s._beforeUpdate(t, s._groups), e.each(s._groups, function () {
                s._apply(this.elements, this.options);
            }), s._afterUpdate && s._afterUpdate(t, s._groups);
        };s._update = function (i, o) {
            if (o && "resize" === o.type) {
                var r = e(window).width();if (r === t) return;t = r;
            }i ? n === -1 && (n = setTimeout(function () {
                a(o), n = -1;
            }, s._throttle)) : a(o);
        }, e(s._applyDataApi);var l = e.fn.on ? "on" : "bind";e(window)[l]("load", function (e) {
            s._update(!1, e);
        }), e(window)[l]("resize orientationchange", function (e) {
            s._update(!0, e);
        });
    }), /*!
        * https://github.com/kenwheeler/slick/
        */
    !function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery);
    }(function (e) {
        "use strict";
        var t = window.Slick || {};(t = function () {
            var t = 0;return function (n, i) {
                var o,
                    r = this;r.defaults = { accessibility: !0, adaptiveHeight: !1, appendArrows: e(n), appendDots: e(n), arrows: !0, asNavFor: null, prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>', nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>', autoplay: !1, autoplaySpeed: 3e3, centerMode: !1, centerPadding: "50px", cssEase: "ease", customPaging: function customPaging(t, n) {
                        return e('<button type="button" />').text(n + 1);
                    }, dots: !1, dotsClass: "slick-dots", draggable: !0, easing: "linear", edgeFriction: .35, fade: !1, focusOnSelect: !1, focusOnChange: !1, infinite: !0, initialSlide: 0, lazyLoad: "ondemand", mobileFirst: !1, pauseOnHover: !0, pauseOnFocus: !0, pauseOnDotsHover: !1, respondTo: "window", responsive: null, rows: 1, rtl: !1, slide: "", slidesPerRow: 1, slidesToShow: 1, slidesToScroll: 1, speed: 500, swipe: !0, swipeToSlide: !1, touchMove: !0, touchThreshold: 5, useCSS: !0, useTransform: !0, variableWidth: !1, vertical: !1, verticalSwiping: !1, waitForAnimate: !0, zIndex: 1e3 }, r.initials = { animating: !1, dragging: !1, autoPlayTimer: null, currentDirection: 0, currentLeft: null, currentSlide: 0, direction: 1, $dots: null, listWidth: null, listHeight: null, loadIndex: 0, $nextArrow: null, $prevArrow: null, scrolling: !1, slideCount: null, slideWidth: null, $slideTrack: null, $slides: null, sliding: !1, slideOffset: 0, swipeLeft: null, swiping: !1, $list: null, touchObject: {}, transformsEnabled: !1, unslicked: !1 }, e.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.focussed = !1, r.interrupted = !1, r.hidden = "hidden", r.paused = !0, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = e(n), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, o = e(n).data("slick") || {}, r.options = e.extend({}, r.defaults, i, o), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, void 0 !== document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = e.proxy(r.autoPlay, r), r.autoPlayClear = e.proxy(r.autoPlayClear, r), r.autoPlayIterator = e.proxy(r.autoPlayIterator, r), r.changeSlide = e.proxy(r.changeSlide, r), r.clickHandler = e.proxy(r.clickHandler, r), r.selectHandler = e.proxy(r.selectHandler, r), r.setPosition = e.proxy(r.setPosition, r), r.swipeHandler = e.proxy(r.swipeHandler, r), r.dragHandler = e.proxy(r.dragHandler, r), r.keyHandler = e.proxy(r.keyHandler, r), r.instanceUid = t++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0);
            };
        }()).prototype.activateADA = function () {
            this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
        }, t.prototype.addSlide = t.prototype.slickAdd = function (t, n, i) {
            var o = this;if ("boolean" == typeof n) i = n, n = null;else if (n < 0 || n >= o.slideCount) return !1;o.unload(), "number" == typeof n ? 0 === n && 0 === o.$slides.length ? e(t).appendTo(o.$slideTrack) : i ? e(t).insertBefore(o.$slides.eq(n)) : e(t).insertAfter(o.$slides.eq(n)) : !0 === i ? e(t).prependTo(o.$slideTrack) : e(t).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function (t, n) {
                e(n).attr("data-slick-index", t);
            }), o.$slidesCache = o.$slides, o.reinit();
        }, t.prototype.animateHeight = function () {
            var e = this;if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                var t = e.$slides.eq(e.currentSlide).outerHeight(!0);e.$list.animate({ height: t }, e.options.speed);
            }
        }, t.prototype.animateSlide = function (t, n) {
            var i = {},
                o = this;o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (t = -t), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({ left: t }, o.options.speed, o.options.easing, n) : o.$slideTrack.animate({ top: t }, o.options.speed, o.options.easing, n) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), e({ animStart: o.currentLeft }).animate({ animStart: t }, { duration: o.options.speed, easing: o.options.easing, step: function step(e) {
                    e = Math.ceil(e), !1 === o.options.vertical ? (i[o.animType] = "translate(" + e + "px, 0px)", o.$slideTrack.css(i)) : (i[o.animType] = "translate(0px," + e + "px)", o.$slideTrack.css(i));
                }, complete: function complete() {
                    n && n.call();
                } })) : (o.applyTransition(), t = Math.ceil(t), !1 === o.options.vertical ? i[o.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[o.animType] = "translate3d(0px," + t + "px, 0px)", o.$slideTrack.css(i), n && setTimeout(function () {
                o.disableTransition(), n.call();
            }, o.options.speed));
        }, t.prototype.getNavTarget = function () {
            var t = this,
                n = t.options.asNavFor;return n && null !== n && (n = e(n).not(t.$slider)), n;
        }, t.prototype.asNavFor = function (t) {
            var n = this.getNavTarget();null !== n && "object" == (typeof n === "undefined" ? "undefined" : (0, _typeof3.default)(n)) && n.each(function () {
                var n = e(this).slick("getSlick");n.unslicked || n.slideHandler(t, !0);
            });
        }, t.prototype.applyTransition = function (e) {
            var t = this,
                n = {};!1 === t.options.fade ? n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
        }, t.prototype.autoPlay = function () {
            var e = this;e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
        }, t.prototype.autoPlayClear = function () {
            var e = this;e.autoPlayTimer && clearInterval(e.autoPlayTimer);
        }, t.prototype.autoPlayIterator = function () {
            var e = this,
                t = e.currentSlide + e.options.slidesToScroll;e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t));
        }, t.prototype.buildArrows = function () {
            var t = this;!0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
        }, t.prototype.buildDots = function () {
            var t,
                n,
                i = this;if (!0 === i.options.dots) {
                for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) {
                    n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
                }i.$dots = n.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active");
            }
        }, t.prototype.buildOut = function () {
            var t = this;t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), t.slideCount = t.$slides.length, t.$slides.each(function (t, n) {
                e(n).attr("data-slick-index", t).data("originalStyling", e(n).attr("style") || "");
            }), t.$slider.addClass("slick-slider"), t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(), t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(), t.$slideTrack.css("opacity", 0), !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1), e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"), t.setupInfinite(), t.buildArrows(), t.buildDots(), t.updateDots(), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), !0 === t.options.draggable && t.$list.addClass("draggable");
        }, t.prototype.buildRows = function () {
            var e,
                t,
                n,
                i,
                o,
                r,
                s,
                a = this;if (i = document.createDocumentFragment(), r = a.$slider.children(), a.options.rows > 1) {
                for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
                    var l = document.createElement("div");for (t = 0; t < a.options.rows; t++) {
                        var c = document.createElement("div");for (n = 0; n < a.options.slidesPerRow; n++) {
                            var d = e * s + (t * a.options.slidesPerRow + n);r.get(d) && c.appendChild(r.get(d));
                        }l.appendChild(c);
                    }i.appendChild(l);
                }a.$slider.empty().append(i), a.$slider.children().children().children().css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
            }
        }, t.prototype.checkResponsive = function (t, n) {
            var i,
                o,
                r,
                s = this,
                a = !1,
                l = s.$slider.width(),
                c = window.innerWidth || e(window).width();if ("window" === s.respondTo ? r = c : "slider" === s.respondTo ? r = l : "min" === s.respondTo && (r = Math.min(c, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
                o = null;for (i in s.breakpoints) {
                    s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
                }null !== o ? null !== s.activeBreakpoint ? (o !== s.activeBreakpoint || n) && (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t), a = o), t || !1 === a || s.$slider.trigger("breakpoint", [s, a]);
            }
        }, t.prototype.changeSlide = function (t, n) {
            var i,
                o,
                r,
                s = this,
                a = e(t.currentTarget);switch (a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), r = s.slideCount % s.options.slidesToScroll != 0, i = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, t.data.message) {case "previous":
                    o = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, n);break;case "next":
                    o = 0 === i ? s.options.slidesToScroll : i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, n);break;case "index":
                    var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");break;default:
                    return;}
        }, t.prototype.checkNavigable = function (e) {
            var t, n;if (t = this.getNavigableIndexes(), n = 0, e > t[t.length - 1]) e = t[t.length - 1];else for (var i in t) {
                if (e < t[i]) {
                    e = n;break;
                }n = t[i];
            }return e;
        }, t.prototype.cleanUpEvents = function () {
            var t = this;t.options.dots && null !== t.$dots && (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)), !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)), t.$slider.off("focus.slick blur.slick"), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))), t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler), t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler), t.$list.off("touchend.slick mouseup.slick", t.swipeHandler), t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler), t.$list.off("click.slick", t.clickHandler), e(document).off(t.visibilityChange, t.visibility), t.cleanUpSlideEvents(), !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler), e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange), e(window).off("resize.slick.slick-" + t.instanceUid, t.resize), e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault), e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition);
        }, t.prototype.cleanUpSlideEvents = function () {
            var t = this;t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
        }, t.prototype.cleanUpRows = function () {
            var e,
                t = this;t.options.rows > 1 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e));
        }, t.prototype.clickHandler = function (e) {
            !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
        }, t.prototype.destroy = function (t) {
            var n = this;n.autoPlayClear(), n.touchObject = {}, n.cleanUpEvents(), e(".slick-cloned", n.$slider).detach(), n.$dots && n.$dots.remove(), n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()), n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()), n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
                e(this).attr("style", e(this).data("originalStyling"));
            }), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.detach(), n.$list.detach(), n.$slider.append(n.$slides)), n.cleanUpRows(), n.$slider.removeClass("slick-slider"), n.$slider.removeClass("slick-initialized"), n.$slider.removeClass("slick-dotted"), n.unslicked = !0, t || n.$slider.trigger("destroy", [n]);
        }, t.prototype.disableTransition = function (e) {
            var t = this,
                n = {};n[t.transitionType] = "", !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
        }, t.prototype.fadeSlide = function (e, t) {
            var n = this;!1 === n.cssTransitions ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }), n.$slides.eq(e).animate({ opacity: 1 }, n.options.speed, n.options.easing, t)) : (n.applyTransition(e), n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }), t && setTimeout(function () {
                n.disableTransition(e), t.call();
            }, n.options.speed));
        }, t.prototype.fadeSlideOut = function (e) {
            var t = this;!1 === t.cssTransitions ? t.$slides.eq(e).animate({ opacity: 0, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
        }, t.prototype.filterSlides = t.prototype.slickFilter = function (e) {
            var t = this;null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
        }, t.prototype.focusHandler = function () {
            var t = this;t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (n) {
                n.stopImmediatePropagation();var i = e(this);setTimeout(function () {
                    t.options.pauseOnFocus && (t.focussed = i.is(":focus"), t.autoPlay());
                }, 0);
            });
        }, t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
            return this.currentSlide;
        }, t.prototype.getDotCount = function () {
            var e = this,
                t = 0,
                n = 0,
                i = 0;if (!0 === e.options.infinite) {
                if (e.slideCount <= e.options.slidesToShow) ++i;else for (; t < e.slideCount;) {
                    ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
                }
            } else if (!0 === e.options.centerMode) i = e.slideCount;else if (e.options.asNavFor) for (; t < e.slideCount;) {
                ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            } else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);return i - 1;
        }, t.prototype.getLeft = function (e) {
            var t,
                n,
                i,
                o,
                r = this,
                s = 0;return r.slideOffset = 0, n = r.$slides.first().outerHeight(!0), !0 === r.options.infinite ? (r.slideCount > r.options.slidesToShow && (r.slideOffset = r.slideWidth * r.options.slidesToShow * -1, o = -1, !0 === r.options.vertical && !0 === r.options.centerMode && (2 === r.options.slidesToShow ? o = -1.5 : 1 === r.options.slidesToShow && (o = -2)), s = n * r.options.slidesToShow * o), r.slideCount % r.options.slidesToScroll != 0 && e + r.options.slidesToScroll > r.slideCount && r.slideCount > r.options.slidesToShow && (e > r.slideCount ? (r.slideOffset = (r.options.slidesToShow - (e - r.slideCount)) * r.slideWidth * -1, s = (r.options.slidesToShow - (e - r.slideCount)) * n * -1) : (r.slideOffset = r.slideCount % r.options.slidesToScroll * r.slideWidth * -1, s = r.slideCount % r.options.slidesToScroll * n * -1))) : e + r.options.slidesToShow > r.slideCount && (r.slideOffset = (e + r.options.slidesToShow - r.slideCount) * r.slideWidth, s = (e + r.options.slidesToShow - r.slideCount) * n), r.slideCount <= r.options.slidesToShow && (r.slideOffset = 0, s = 0), !0 === r.options.centerMode && r.slideCount <= r.options.slidesToShow ? r.slideOffset = r.slideWidth * Math.floor(r.options.slidesToShow) / 2 - r.slideWidth * r.slideCount / 2 : !0 === r.options.centerMode && !0 === r.options.infinite ? r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2) - r.slideWidth : !0 === r.options.centerMode && (r.slideOffset = 0, r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2)), t = !1 === r.options.vertical ? e * r.slideWidth * -1 + r.slideOffset : e * n * -1 + s, !0 === r.options.variableWidth && (i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow), t = !0 === r.options.rtl ? i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === r.options.centerMode && (i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow + 1), t = !0 === r.options.rtl ? i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (r.$list.width() - i.outerWidth()) / 2)), t;
        }, t.prototype.getOption = t.prototype.slickGetOption = function (e) {
            return this.options[e];
        }, t.prototype.getNavigableIndexes = function () {
            var e,
                t = this,
                n = 0,
                i = 0,
                o = [];for (!1 === t.options.infinite ? e = t.slideCount : (n = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, e = 2 * t.slideCount); n < e;) {
                o.push(n), n = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
            }return o;
        }, t.prototype.getSlick = function () {
            return this;
        }, t.prototype.getSlideCount = function () {
            var t,
                n,
                i = this;return n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each(function (o, r) {
                if (r.offsetLeft - n + e(r).outerWidth() / 2 > -1 * i.swipeLeft) return t = r, !1;
            }), Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll;
        }, t.prototype.goTo = t.prototype.slickGoTo = function (e, t) {
            this.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
        }, t.prototype.init = function (t) {
            var n = this;e(n.$slider).hasClass("slick-initialized") || (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()), t && n.$slider.trigger("init", [n]), !0 === n.options.accessibility && n.initADA(), n.options.autoplay && (n.paused = !1, n.autoPlay());
        }, t.prototype.initADA = function () {
            var t = this,
                n = Math.ceil(t.slideCount / t.options.slidesToShow),
                i = t.getNavigableIndexes().filter(function (e) {
                return e >= 0 && e < t.slideCount;
            });t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (n) {
                var o = i.indexOf(n);e(this).attr({ role: "tabpanel", id: "slick-slide" + t.instanceUid + n, tabindex: -1 }), -1 !== o && e(this).attr({ "aria-describedby": "slick-slide-control" + t.instanceUid + o });
            }), t.$dots.attr("role", "tablist").find("li").each(function (o) {
                var r = i[o];e(this).attr({ role: "presentation" }), e(this).find("button").first().attr({ role: "tab", id: "slick-slide-control" + t.instanceUid + o, "aria-controls": "slick-slide" + t.instanceUid + r, "aria-label": o + 1 + " of " + n, "aria-selected": null, tabindex: "-1" });
            }).eq(t.currentSlide).find("button").attr({ "aria-selected": "true", tabindex: "0" }).end());for (var o = t.currentSlide, r = o + t.options.slidesToShow; o < r; o++) {
                t.$slides.eq(o).attr("tabindex", 0);
            }t.activateADA();
        }, t.prototype.initArrowEvents = function () {
            var e = this;!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)));
        }, t.prototype.initDotEvents = function () {
            var t = this;!0 === t.options.dots && (e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)), !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
        }, t.prototype.initSlideEvents = function () {
            var t = this;t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
        }, t.prototype.initializeEvents = function () {
            var t = this;t.initArrowEvents(), t.initDotEvents(), t.initSlideEvents(), t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler), t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler), t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler), t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler), t.$list.on("click.slick", t.clickHandler), e(document).on(t.visibilityChange, e.proxy(t.visibility, t)), !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)), e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)), e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault), e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition), e(t.setPosition);
        }, t.prototype.initUI = function () {
            var e = this;!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show();
        }, t.prototype.keyHandler = function (e) {
            var t = this;e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({ data: { message: !0 === t.options.rtl ? "next" : "previous" } }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({ data: { message: !0 === t.options.rtl ? "previous" : "next" } }));
        }, t.prototype.lazyLoad = function () {
            function t(t) {
                e("img[data-lazy]", t).each(function () {
                    var t = e(this),
                        n = e(this).attr("data-lazy"),
                        i = e(this).attr("data-srcset"),
                        o = e(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
                        s = document.createElement("img");s.onload = function () {
                        t.animate({ opacity: 0 }, 100, function () {
                            i && (t.attr("srcset", i), o && t.attr("sizes", o)), t.attr("src", n).animate({ opacity: 1 }, 200, function () {
                                t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                            }), r.$slider.trigger("lazyLoaded", [r, t, n]);
                        });
                    }, s.onerror = function () {
                        t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), r.$slider.trigger("lazyLoadError", [r, t, n]);
                    }, s.src = n;
                });
            }var n,
                i,
                o,
                r = this;if (!0 === r.options.centerMode ? !0 === r.options.infinite ? o = (i = r.currentSlide + (r.options.slidesToShow / 2 + 1)) + r.options.slidesToShow + 2 : (i = Math.max(0, r.currentSlide - (r.options.slidesToShow / 2 + 1)), o = r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide) : (i = r.options.infinite ? r.options.slidesToShow + r.currentSlide : r.currentSlide, o = Math.ceil(i + r.options.slidesToShow), !0 === r.options.fade && (i > 0 && i--, o <= r.slideCount && o++)), n = r.$slider.find(".slick-slide").slice(i, o), "anticipated" === r.options.lazyLoad) for (var s = i - 1, a = o, l = r.$slider.find(".slick-slide"), c = 0; c < r.options.slidesToScroll; c++) {
                s < 0 && (s = r.slideCount - 1), n = (n = n.add(l.eq(s))).add(l.eq(a)), s--, a++;
            }t(n), r.slideCount <= r.options.slidesToShow ? t(r.$slider.find(".slick-slide")) : r.currentSlide >= r.slideCount - r.options.slidesToShow ? t(r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)) : 0 === r.currentSlide && t(r.$slider.find(".slick-cloned").slice(-1 * r.options.slidesToShow));
        }, t.prototype.loadSlider = function () {
            var e = this;e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
        }, t.prototype.next = t.prototype.slickNext = function () {
            this.changeSlide({ data: { message: "next" } });
        }, t.prototype.orientationChange = function () {
            var e = this;e.checkResponsive(), e.setPosition();
        }, t.prototype.pause = t.prototype.slickPause = function () {
            var e = this;e.autoPlayClear(), e.paused = !0;
        }, t.prototype.play = t.prototype.slickPlay = function () {
            var e = this;e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1;
        }, t.prototype.postSlide = function (t) {
            var n = this;n.unslicked || (n.$slider.trigger("afterChange", [n, t]), n.animating = !1, n.slideCount > n.options.slidesToShow && n.setPosition(), n.swipeLeft = null, n.options.autoplay && n.autoPlay(), !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange && e(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()));
        }, t.prototype.prev = t.prototype.slickPrev = function () {
            this.changeSlide({ data: { message: "previous" } });
        }, t.prototype.preventDefault = function (e) {
            e.preventDefault();
        }, t.prototype.progressiveLazyLoad = function (t) {
            t = t || 1;var n,
                i,
                o,
                r,
                s,
                a = this,
                l = e("img[data-lazy]", a.$slider);l.length ? (n = l.first(), i = n.attr("data-lazy"), o = n.attr("data-srcset"), r = n.attr("data-sizes") || a.$slider.attr("data-sizes"), (s = document.createElement("img")).onload = function () {
                o && (n.attr("srcset", o), r && n.attr("sizes", r)), n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === a.options.adaptiveHeight && a.setPosition(), a.$slider.trigger("lazyLoaded", [a, n, i]), a.progressiveLazyLoad();
            }, s.onerror = function () {
                t < 3 ? setTimeout(function () {
                    a.progressiveLazyLoad(t + 1);
                }, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad());
            }, s.src = i) : a.$slider.trigger("allImagesLoaded", [a]);
        }, t.prototype.refresh = function (t) {
            var n,
                i,
                o = this;i = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > i && (o.currentSlide = i), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), n = o.currentSlide, o.destroy(!0), e.extend(o, o.initials, { currentSlide: n }), o.init(), t || o.changeSlide({ data: { message: "index", index: n } }, !1);
        }, t.prototype.registerBreakpoints = function () {
            var t,
                n,
                i,
                o = this,
                r = o.options.responsive || null;if ("array" === e.type(r) && r.length) {
                o.respondTo = o.options.respondTo || "window";for (t in r) {
                    if (i = o.breakpoints.length - 1, r.hasOwnProperty(t)) {
                        for (n = r[t].breakpoint; i >= 0;) {
                            o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
                        }o.breakpoints.push(n), o.breakpointSettings[n] = r[t].settings;
                    }
                }o.breakpoints.sort(function (e, t) {
                    return o.options.mobileFirst ? e - t : t - e;
                });
            }
        }, t.prototype.reinit = function () {
            var t = this;t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"), t.slideCount = t.$slides.length, t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), t.registerBreakpoints(), t.setProps(), t.setupInfinite(), t.buildArrows(), t.updateArrows(), t.initArrowEvents(), t.buildDots(), t.updateDots(), t.initDotEvents(), t.cleanUpSlideEvents(), t.initSlideEvents(), t.checkResponsive(!1, !0), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), t.setPosition(), t.focusHandler(), t.paused = !t.options.autoplay, t.autoPlay(), t.$slider.trigger("reInit", [t]);
        }, t.prototype.resize = function () {
            var t = this;e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout(function () {
                t.windowWidth = e(window).width(), t.checkResponsive(), t.unslicked || t.setPosition();
            }, 50));
        }, t.prototype.removeSlide = t.prototype.slickRemove = function (e, t, n) {
            var i = this;return e = "boolean" == typeof e ? !0 === (t = e) ? 0 : i.slideCount - 1 : !0 === t ? --e : e, !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) && (i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, i.reinit(), void 0);
        }, t.prototype.setCSS = function (e) {
            var t,
                n,
                i = this,
                o = {};!0 === i.options.rtl && (e = -e), t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px", o[i.positionProp] = e, !1 === i.transformsEnabled ? i.$slideTrack.css(o) : (o = {}, !1 === i.cssTransitions ? (o[i.animType] = "translate(" + t + ", " + n + ")", i.$slideTrack.css(o)) : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)", i.$slideTrack.css(o)));
        }, t.prototype.setDimensions = function () {
            var e = this;!1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({ padding: "0px " + e.options.centerPadding }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({ padding: e.options.centerPadding + " 0px" })), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();!1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
        }, t.prototype.setFade = function () {
            var t,
                n = this;n.$slides.each(function (i, o) {
                t = n.slideWidth * i * -1, !0 === n.options.rtl ? e(o).css({ position: "relative", right: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 }) : e(o).css({ position: "relative", left: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 0 });
            }), n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
        }, t.prototype.setHeight = function () {
            var e = this;if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                var t = e.$slides.eq(e.currentSlide).outerHeight(!0);e.$list.css("height", t);
            }
        }, t.prototype.setOption = t.prototype.slickSetOption = function () {
            var t,
                n,
                i,
                o,
                r,
                s = this,
                a = !1;if ("object" === e.type(arguments[0]) ? (i = arguments[0], a = arguments[1], r = "multiple") : "string" === e.type(arguments[0]) && (i = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? r = "responsive" : void 0 !== arguments[1] && (r = "single")), "single" === r) s.options[i] = o;else if ("multiple" === r) e.each(i, function (e, t) {
                s.options[e] = t;
            });else if ("responsive" === r) for (n in o) {
                if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];else {
                    for (t = s.options.responsive.length - 1; t >= 0;) {
                        s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
                    }s.options.responsive.push(o[n]);
                }
            }a && (s.unload(), s.reinit());
        }, t.prototype.setPosition = function () {
            var e = this;e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
        }, t.prototype.setProps = function () {
            var e = this,
                t = document.body.style;e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType;
        }, t.prototype.setSlideClasses = function (e) {
            var t,
                n,
                i,
                o,
                r = this;if (n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), r.$slides.eq(e).addClass("slick-current"), !0 === r.options.centerMode) {
                var s = r.options.slidesToShow % 2 == 0 ? 1 : 0;t = Math.floor(r.options.slidesToShow / 2), !0 === r.options.infinite && (e >= t && e <= r.slideCount - 1 - t ? r.$slides.slice(e - t + s, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = r.options.slidesToShow + e, n.slice(i - t + 1 + s, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")), r.$slides.eq(e).addClass("slick-center");
            } else e >= 0 && e <= r.slideCount - r.options.slidesToShow ? r.$slides.slice(e, e + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= r.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (o = r.slideCount % r.options.slidesToShow, i = !0 === r.options.infinite ? r.options.slidesToShow + e : e, r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow ? n.slice(i - (r.options.slidesToShow - o), i + o).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));"ondemand" !== r.options.lazyLoad && "anticipated" !== r.options.lazyLoad || r.lazyLoad();
        }, t.prototype.setupInfinite = function () {
            var t,
                n,
                i,
                o = this;if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (n = null, o.slideCount > o.options.slidesToShow)) {
                for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1) {
                    n = t - 1, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
                }for (t = 0; t < i + o.slideCount; t += 1) {
                    n = t, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
                }o.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                    e(this).attr("id", "");
                });
            }
        }, t.prototype.interrupt = function (e) {
            var t = this;e || t.autoPlay(), t.interrupted = e;
        }, t.prototype.selectHandler = function (t) {
            var n = this,
                i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
                o = parseInt(i.attr("data-slick-index"));o || (o = 0), n.slideCount <= n.options.slidesToShow ? n.slideHandler(o, !1, !0) : n.slideHandler(o);
        }, t.prototype.slideHandler = function (e, t, n) {
            var i,
                o,
                r,
                s,
                a,
                l = null,
                c = this;if (t = t || !1, !(!0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === e)) if (!1 === t && c.asNavFor(e), i = e, l = c.getLeft(i), s = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft, !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll)) !1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function () {
                c.postSlide(i);
            }) : c.postSlide(i));else if (!1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll)) !1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function () {
                c.postSlide(i);
            }) : c.postSlide(i));else {
                if (c.options.autoplay && clearInterval(c.autoPlayTimer), o = i < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + i : i >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : i - c.slideCount : i, c.animating = !0, c.$slider.trigger("beforeChange", [c, c.currentSlide, o]), r = c.currentSlide, c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && (a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide), c.updateDots(), c.updateArrows(), !0 === c.options.fade) return !0 !== n ? (c.fadeSlideOut(r), c.fadeSlide(o, function () {
                    c.postSlide(o);
                })) : c.postSlide(o), void c.animateHeight();!0 !== n ? c.animateSlide(l, function () {
                    c.postSlide(o);
                }) : c.postSlide(o);
            }
        }, t.prototype.startLoad = function () {
            var e = this;!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading");
        }, t.prototype.swipeDirection = function () {
            var e,
                t,
                n,
                i,
                o = this;return e = o.touchObject.startX - o.touchObject.curX, t = o.touchObject.startY - o.touchObject.curY, n = Math.atan2(t, e), (i = Math.round(180 * n / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 ? !1 === o.options.rtl ? "left" : "right" : i <= 360 && i >= 315 ? !1 === o.options.rtl ? "left" : "right" : i >= 135 && i <= 225 ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? i >= 35 && i <= 135 ? "down" : "up" : "vertical";
        }, t.prototype.swipeEnd = function (e) {
            var t,
                n,
                i = this;if (i.dragging = !1, i.swiping = !1, i.scrolling) return i.scrolling = !1, !1;if (i.interrupted = !1, i.shouldClick = !(i.touchObject.swipeLength > 10), void 0 === i.touchObject.curX) return !1;if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
                switch (n = i.swipeDirection()) {case "left":case "down":
                        t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;break;case "right":case "up":
                        t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1;}"vertical" != n && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]));
            } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {});
        }, t.prototype.swipeHandler = function (e) {
            var t = this;if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {case "start":
                    t.swipeStart(e);break;case "move":
                    t.swipeMove(e);break;case "end":
                    t.swipeEnd(e);}
        }, t.prototype.swipeMove = function (e) {
            var t,
                n,
                i,
                o,
                r,
                s,
                a = this;return r = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!a.dragging || a.scrolling || r && 1 !== r.length) && (t = a.getLeft(a.currentSlide), a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX, a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY, a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))), s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))), !a.options.verticalSwiping && !a.swiping && s > 4 ? (a.scrolling = !0, !1) : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s), n = a.swipeDirection(), void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && (a.swiping = !0, e.preventDefault()), o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1), !0 === a.options.verticalSwiping && (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1), i = a.touchObject.swipeLength, a.touchObject.edgeHit = !1, !1 === a.options.infinite && (0 === a.currentSlide && "right" === n || a.currentSlide >= a.getDotCount() && "left" === n) && (i = a.touchObject.swipeLength * a.options.edgeFriction, a.touchObject.edgeHit = !0), !1 === a.options.vertical ? a.swipeLeft = t + i * o : a.swipeLeft = t + i * (a.$list.height() / a.listWidth) * o, !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * o), !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? (a.swipeLeft = null, !1) : void a.setCSS(a.swipeLeft))));
        }, t.prototype.swipeStart = function (e) {
            var t,
                n = this;return n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow ? (n.touchObject = {}, !1) : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, n.dragging = !0, void 0);
        }, t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
            var e = this;null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
        }, t.prototype.unload = function () {
            var t = this;e(".slick-cloned", t.$slider).remove(), t.$dots && t.$dots.remove(), t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(), t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(), t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
        }, t.prototype.unslick = function (e) {
            var t = this;t.$slider.trigger("unslick", [t, e]), t.destroy();
        }, t.prototype.updateArrows = function () {
            var e = this;Math.floor(e.options.slidesToShow / 2), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
        }, t.prototype.updateDots = function () {
            var e = this;null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"));
        }, t.prototype.visibility = function () {
            var e = this;e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1);
        }, e.fn.slick = function () {
            var e,
                n,
                i = this,
                o = arguments[0],
                r = Array.prototype.slice.call(arguments, 1),
                s = i.length;for (e = 0; e < s; e++) {
                if ("object" == (typeof o === "undefined" ? "undefined" : (0, _typeof3.default)(o)) || void 0 === o ? i[e].slick = new t(i[e], o) : n = i[e].slick[o].apply(i[e].slick, r), void 0 !== n) return n;
            }return i;
        };
    }), function () {
        var e;e = function () {
            function e(e, t) {
                var n, i;if (this.options = { target: "instafeed", get: "popular", resolution: "thumbnail", sortBy: "none", links: !0, mock: !1, useHttp: !1 }, "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e))) for (n in e) {
                    i = e[n], this.options[n] = i;
                }this.context = null != t ? t : this, this.unique = this._genKey();
            }return e.prototype.hasNext = function () {
                return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0;
            }, e.prototype.next = function () {
                return !!this.hasNext() && this.run(this.context.nextUrl);
            }, e.prototype.run = function (t) {
                var n, i, o;if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken) throw new Error("Missing clientId or accessToken.");if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId) throw new Error("Missing clientId or accessToken.");return null != this.options.before && "function" == typeof this.options.before && this.options.before.call(this), "undefined" != typeof document && null !== document && (o = document.createElement("script"), o.id = "instafeed-fetcher", o.src = t || this._buildUrl(), n = document.getElementsByTagName("head"), n[0].appendChild(o), i = "instafeedCache" + this.unique, window[i] = new e(this.options, this), window[i].unique = this.unique), !0;
            }, e.prototype.parse = function (e) {
                var t, n, i, o, r, s, a, l, c, d, u, p, f, h, g, v, m, y, w, b, x, k, T, C, S, $, E, A, j, N, D, O, H;if ("object" != (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e))) {
                    if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "Invalid JSON data"), !1;throw new Error("Invalid JSON response");
                }if (200 !== e.meta.code) {
                    if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, e.meta.error_message), !1;throw new Error("Error from Instagram: " + e.meta.error_message);
                }if (0 === e.data.length) {
                    if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "No images were returned from Instagram"), !1;throw new Error("No images were returned from Instagram");
                }if (null != this.options.success && "function" == typeof this.options.success && this.options.success.call(this, e), this.context.nextUrl = "", null != e.pagination && (this.context.nextUrl = e.pagination.next_url), "none" !== this.options.sortBy) switch (D = "random" === this.options.sortBy ? ["", "random"] : this.options.sortBy.split("-"), N = "least" === D[0], D[1]) {case "random":
                        e.data.sort(function () {
                            return .5 - Math.random();
                        });break;case "recent":
                        e.data = this._sortBy(e.data, "created_time", N);break;case "liked":
                        e.data = this._sortBy(e.data, "likes.count", N);break;case "commented":
                        e.data = this._sortBy(e.data, "comments.count", N);break;default:
                        throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");}if ("undefined" != typeof document && null !== document && this.options.mock === !1) {
                    if (v = e.data, j = parseInt(this.options.limit, 10), null != this.options.limit && v.length > j && (v = v.slice(0, j)), a = document.createDocumentFragment(), null != this.options.filter && "function" == typeof this.options.filter && (v = this._filter(v, this.options.filter)), null != this.options.template && "string" == typeof this.options.template) {
                        for (c = "", h = "", b = "", H = document.createElement("div"), u = 0, S = v.length; u < S; u++) {
                            if (p = v[u], f = p.images[this.options.resolution], "object" != (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f))) throw s = "No image found for resolution: " + this.options.resolution + ".", new Error(s);x = f.width, y = f.height, w = "square", x > y && (w = "landscape"), x < y && (w = "portrait"), g = f.url, d = window.location.protocol.indexOf("http") >= 0, d && !this.options.useHttp && (g = g.replace(/https?:\/\//, "//")), h = this._makeTemplate(this.options.template, { model: p, id: p.id, link: p.link, type: p.type, image: g, width: x, height: y, orientation: w, caption: this._getObjectProperty(p, "caption.text"), likes: p.likes.count, comments: p.comments.count, location: this._getObjectProperty(p, "location.name") }), c += h;
                        }for (H.innerHTML = c, o = [], i = 0, n = H.childNodes.length; i < n;) {
                            o.push(H.childNodes[i]), i += 1;
                        }for (T = 0, $ = o.length; T < $; T++) {
                            A = o[T], a.appendChild(A);
                        }
                    } else for (C = 0, E = v.length; C < E; C++) {
                        if (p = v[C], m = document.createElement("img"), f = p.images[this.options.resolution], "object" != (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f))) throw s = "No image found for resolution: " + this.options.resolution + ".", new Error(s);g = f.url, d = window.location.protocol.indexOf("http") >= 0, d && !this.options.useHttp && (g = g.replace(/https?:\/\//, "//")), m.src = g, this.options.links === !0 ? (t = document.createElement("a"), t.href = p.link, t.appendChild(m), a.appendChild(t)) : a.appendChild(m);
                    }if (O = this.options.target, "string" == typeof O && (O = document.getElementById(O)), null == O) throw s = 'No element with id="' + this.options.target + '" on page.', new Error(s);O.appendChild(a), l = document.getElementsByTagName("head")[0], l.removeChild(document.getElementById("instafeed-fetcher")), k = "instafeedCache" + this.unique, window[k] = void 0;try {
                        delete window[k];
                    } catch (e) {
                        r = e;
                    }
                }return null != this.options.after && "function" == typeof this.options.after && this.options.after.call(this), !0;
            }, e.prototype._buildUrl = function () {
                var e, t, n;switch (e = "https://api.instagram.com/v1", this.options.get) {case "popular":
                        t = "media/popular";break;case "tagged":
                        if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");t = "tags/" + this.options.tagName + "/media/recent";break;case "location":
                        if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");t = "locations/" + this.options.locationId + "/media/recent";break;case "user":
                        if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");t = "users/" + this.options.userId + "/media/recent";break;default:
                        throw new Error("Invalid option for get: '" + this.options.get + "'.");}return n = e + "/" + t, n += null != this.options.accessToken ? "?access_token=" + this.options.accessToken : "?client_id=" + this.options.clientId, null != this.options.limit && (n += "&count=" + this.options.limit), n += "&callback=instafeedCache" + this.unique + ".parse";
            }, e.prototype._genKey = function () {
                var e;return e = function e() {
                    return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
                }, "" + e() + e() + e() + e();
            }, e.prototype._makeTemplate = function (e, t) {
                var n, i, o, r, s;for (i = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, n = e; i.test(n);) {
                    r = n.match(i)[1], s = null != (o = this._getObjectProperty(t, r)) ? o : "", n = n.replace(i, function () {
                        return "" + s;
                    });
                }return n;
            }, e.prototype._getObjectProperty = function (e, t) {
                var n, i;for (t = t.replace(/\[(\w+)\]/g, ".$1"), i = t.split("."); i.length;) {
                    if (n = i.shift(), !(null != e && n in e)) return null;e = e[n];
                }return e;
            }, e.prototype._sortBy = function (e, t, n) {
                var i;return i = function i(e, _i) {
                    var o, r;return o = this._getObjectProperty(e, t), r = this._getObjectProperty(_i, t), n ? o > r ? 1 : -1 : o < r ? 1 : -1;
                }, e.sort(i.bind(this)), e;
            }, e.prototype._filter = function (e, t) {
                var n, i, o, r, s;for (n = [], i = function i(e) {
                    if (t(e)) return n.push(e);
                }, o = 0, s = e.length; o < s; o++) {
                    r = e[o], i(r);
                }return n;
            }, e;
        }(), function (e, t) {
            return "function" == typeof define && define.amd ? define([], t) : "object" == (typeof module === "undefined" ? "undefined" : (0, _typeof3.default)(module)) && module.exports ? module.exports = t() : e.Instafeed = t();
        }(this, function () {
            return e;
        });
    }.call(this), /**
                  * Featherlight - ultra slim jQuery lightbox
                  * Version 1.7.13 - http://noelboss.github.io/featherlight/
                  *
                  * Copyright 2018, NoÃ«l Raoul Bossart (http://www.noelboss.com)
                  * MIT Licensed.
                  **/
    !function (e) {
        "use strict";
        function t(e, n) {
            if (!(this instanceof t)) {
                var i = new t(e, n);return i.open(), i;
            }this.id = t.id++, this.setup(e, n), this.chainCallbacks(t._callbackChain);
        }function n(e, t) {
            var n = {};for (var i in e) {
                i in t && (n[i] = e[i], delete e[i]);
            }return n;
        }function i(e, t) {
            var n = {},
                i = new RegExp("^" + t + "([A-Z])(.*)");for (var o in e) {
                var r = o.match(i);if (r) {
                    var s = (r[1] + r[2].replace(/([A-Z])/g, "-$1")).toLowerCase();n[s] = e[o];
                }
            }return n;
        }if ("undefined" == typeof e) return void ("console" in window && window.console.info("Too much lightness, Featherlight needs jQuery."));if (e.fn.jquery.match(/-ajax/)) return void ("console" in window && window.console.info("Featherlight needs regular jQuery, not the slim version."));var o = [],
            r = function r(t) {
            return o = e.grep(o, function (e) {
                return e !== t && e.$instance.closest("body").length > 0;
            });
        },
            s = { allow: 1, allowfullscreen: 1, frameborder: 1, height: 1, longdesc: 1, marginheight: 1, marginwidth: 1, mozallowfullscreen: 1, name: 1, referrerpolicy: 1, sandbox: 1, scrolling: 1, src: 1, srcdoc: 1, style: 1, webkitallowfullscreen: 1, width: 1 },
            a = { keyup: "onKeyUp", resize: "onResize" },
            l = function l(n) {
            e.each(t.opened().reverse(), function () {
                return n.isDefaultPrevented() || !1 !== this[a[n.type]](n) ? void 0 : (n.preventDefault(), n.stopPropagation(), !1);
            });
        },
            c = function c(n) {
            if (n !== t._globalHandlerInstalled) {
                t._globalHandlerInstalled = n;var i = e.map(a, function (e, n) {
                    return n + "." + t.prototype.namespace;
                }).join(" ");e(window)[n ? "on" : "off"](i, l);
            }
        };t.prototype = { constructor: t, namespace: "featherlight", targetAttr: "data-featherlight", variant: null, resetCss: !1, background: null, openTrigger: "click", closeTrigger: "click", filter: null, root: "body", openSpeed: 250, closeSpeed: 250, closeOnClick: "background", closeOnEsc: !0, closeIcon: "&#10005;", loading: "", persist: !1, otherClose: null, beforeOpen: e.noop, beforeContent: e.noop, beforeClose: e.noop, afterOpen: e.noop, afterContent: e.noop, afterClose: e.noop, onKeyUp: e.noop, onResize: e.noop, type: null, contentFilters: ["jquery", "image", "html", "ajax", "iframe", "text"], setup: function setup(t, n) {
                "object" != (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) || t instanceof e != 0 || n || (n = t, t = void 0);var i = e.extend(this, n, { target: t }),
                    o = i.resetCss ? i.namespace + "-reset" : i.namespace,
                    r = e(i.background || ['<div class="' + o + "-loading " + o + '">', '<div class="' + o + '-content">', '<button class="' + o + "-close-icon " + i.namespace + '-close" aria-label="Close">', i.closeIcon, "</button>", '<div class="' + i.namespace + '-inner">' + i.loading + "</div>", "</div>", "</div>"].join("")),
                    s = "." + i.namespace + "-close" + (i.otherClose ? "," + i.otherClose : "");return i.$instance = r.clone().addClass(i.variant), i.$instance.on(i.closeTrigger + "." + i.namespace, function (t) {
                    if (!t.isDefaultPrevented()) {
                        var n = e(t.target);("background" === i.closeOnClick && n.is("." + i.namespace) || "anywhere" === i.closeOnClick || n.closest(s).length) && (i.close(t), t.preventDefault());
                    }
                }), this;
            }, getContent: function getContent() {
                if (this.persist !== !1 && this.$content) return this.$content;var t = this,
                    n = this.constructor.contentFilters,
                    i = function i(e) {
                    return t.$currentTarget && t.$currentTarget.attr(e);
                },
                    o = i(t.targetAttr),
                    r = t.target || o || "",
                    s = n[t.type];if (!s && r in n && (s = n[r], r = t.target && o), r = r || i("href") || "", !s) for (var a in n) {
                    t[a] && (s = n[a], r = t[a]);
                }if (!s) {
                    var l = r;if (r = null, e.each(t.contentFilters, function () {
                        return s = n[this], s.test && (r = s.test(l)), !r && s.regex && l.match && l.match(s.regex) && (r = l), !r;
                    }), !r) return "console" in window && window.console.error("Featherlight: no content filter found " + (l ? ' for "' + l + '"' : " (no target specified)")), !1;
                }return s.process.call(t, r);
            }, setContent: function setContent(t) {
                return this.$instance.removeClass(this.namespace + "-loading"), this.$instance.toggleClass(this.namespace + "-iframe", t.is("iframe")), this.$instance.find("." + this.namespace + "-inner").not(t).slice(1).remove().end().replaceWith(e.contains(this.$instance[0], t[0]) ? "" : t), this.$content = t.addClass(this.namespace + "-inner"), this;
            }, open: function open(t) {
                var n = this;if (n.$instance.hide().appendTo(n.root), !(t && t.isDefaultPrevented() || n.beforeOpen(t) === !1)) {
                    t && t.preventDefault();var i = n.getContent();if (i) return o.push(n), c(!0), n.$instance.fadeIn(n.openSpeed), n.beforeContent(t), e.when(i).always(function (e) {
                        n.setContent(e), n.afterContent(t);
                    }).then(n.$instance.promise()).done(function () {
                        n.afterOpen(t);
                    });
                }return n.$instance.detach(), e.Deferred().reject().promise();
            }, close: function close(t) {
                var n = this,
                    i = e.Deferred();return n.beforeClose(t) === !1 ? i.reject() : (0 === r(n).length && c(!1), n.$instance.fadeOut(n.closeSpeed, function () {
                    n.$instance.detach(), n.afterClose(t), i.resolve();
                })), i.promise();
            }, resize: function resize(e, t) {
                if (e && t) {
                    this.$content.css("width", "").css("height", "");var n = Math.max(e / (this.$content.parent().width() - 1), t / (this.$content.parent().height() - 1));n > 1 && (n = t / Math.floor(t / n), this.$content.css("width", "" + e / n + "px").css("height", "" + t / n + "px"));
                }
            }, chainCallbacks: function chainCallbacks(t) {
                for (var n in t) {
                    this[n] = e.proxy(t[n], this, e.proxy(this[n], this));
                }
            } }, e.extend(t, { id: 0, autoBind: "[data-featherlight]", defaults: t.prototype, contentFilters: { jquery: { regex: /^[#.]\w/, test: function test(t) {
                        return t instanceof e && t;
                    }, process: function process(t) {
                        return this.persist !== !1 ? e(t) : e(t).clone(!0);
                    } }, image: { regex: /\.(png|jpg|jpeg|gif|tiff?|bmp|svg)(\?\S*)?$/i, process: function process(t) {
                        var n = this,
                            i = e.Deferred(),
                            o = new Image(),
                            r = e('<img src="' + t + '" alt="" class="' + n.namespace + '-image" />');return o.onload = function () {
                            r.naturalWidth = o.width, r.naturalHeight = o.height, i.resolve(r);
                        }, o.onerror = function () {
                            i.reject(r);
                        }, o.src = t, i.promise();
                    } }, html: { regex: /^\s*<[\w!][^<]*>/, process: function process(t) {
                        return e(t);
                    } }, ajax: { regex: /./, process: function process(t) {
                        var n = e.Deferred(),
                            i = e("<div></div>").load(t, function (e, t) {
                            "error" !== t && n.resolve(i.contents()), n.fail();
                        });return n.promise();
                    } }, iframe: { process: function process(t) {
                        var o = new e.Deferred(),
                            r = e("<iframe/>"),
                            a = i(this, "iframe"),
                            l = n(a, s);return r.hide().attr("src", t).attr(l).css(a).on("load", function () {
                            o.resolve(r.show());
                        }).appendTo(this.$instance.find("." + this.namespace + "-content")), o.promise();
                    } }, text: { process: function process(t) {
                        return e("<div>", { text: t });
                    } } }, functionAttributes: ["beforeOpen", "afterOpen", "beforeContent", "afterContent", "beforeClose", "afterClose"], readElementConfig: function readElementConfig(t, n) {
                var i = this,
                    o = new RegExp("^data-" + n + "-(.*)"),
                    r = {};return t && t.attributes && e.each(t.attributes, function () {
                    var t = this.name.match(o);if (t) {
                        var n = this.value,
                            s = e.camelCase(t[1]);if (e.inArray(s, i.functionAttributes) >= 0) n = new Function(n);else try {
                            n = JSON.parse(n);
                        } catch (e) {}r[s] = n;
                    }
                }), r;
            }, extend: function extend(t, n) {
                var i = function i() {
                    this.constructor = t;
                };return i.prototype = this.prototype, t.prototype = new i(), t.__super__ = this.prototype, e.extend(t, this, n), t.defaults = t.prototype, t;
            }, attach: function attach(t, n, i) {
                var o = this;"object" != (typeof n === "undefined" ? "undefined" : (0, _typeof3.default)(n)) || n instanceof e != 0 || i || (i = n, n = void 0), i = e.extend({}, i);var r,
                    s = i.namespace || o.defaults.namespace,
                    a = e.extend({}, o.defaults, o.readElementConfig(t[0], s), i),
                    l = function l(s) {
                    var l = e(s.currentTarget),
                        c = e.extend({ $source: t, $currentTarget: l }, o.readElementConfig(t[0], a.namespace), o.readElementConfig(s.currentTarget, a.namespace), i),
                        d = r || l.data("featherlight-persisted") || new o(n, c);"shared" === d.persist ? r = d : d.persist !== !1 && l.data("featherlight-persisted", d), c.$currentTarget.blur && c.$currentTarget.blur(), d.open(s);
                };return t.on(a.openTrigger + "." + a.namespace, a.filter, l), { filter: a.filter, handler: l };
            }, current: function current() {
                var e = this.opened();return e[e.length - 1] || null;
            }, opened: function opened() {
                var t = this;return r(), e.grep(o, function (e) {
                    return e instanceof t;
                });
            }, close: function close(e) {
                var t = this.current();return t ? t.close(e) : void 0;
            }, _onReady: function _onReady() {
                var t = this;if (t.autoBind) {
                    var n = e(t.autoBind);n.each(function () {
                        t.attach(e(this));
                    }), e(document).on("click", t.autoBind, function (i) {
                        if (!i.isDefaultPrevented()) {
                            var o = e(i.currentTarget),
                                r = n.length;if (n = n.add(o), r !== n.length) {
                                var s = t.attach(o);(!s.filter || e(i.target).parentsUntil(o, s.filter).length > 0) && s.handler(i);
                            }
                        }
                    });
                }
            }, _callbackChain: { onKeyUp: function onKeyUp(t, n) {
                    return 27 === n.keyCode ? (this.closeOnEsc && e.featherlight.close(n), !1) : t(n);
                }, beforeOpen: function beforeOpen(t, n) {
                    return e(document.documentElement).addClass("with-featherlight"), this._previouslyActive = document.activeElement, this._$previouslyTabbable = e("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]").not("[tabindex]").not(this.$instance.find("button")), this._$previouslyWithTabIndex = e("[tabindex]").not('[tabindex="-1"]'), this._previousWithTabIndices = this._$previouslyWithTabIndex.map(function (t, n) {
                        return e(n).attr("tabindex");
                    }), this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr("tabindex", -1), document.activeElement.blur && document.activeElement.blur(), t(n);
                }, afterClose: function afterClose(n, i) {
                    var o = n(i),
                        r = this;return this._$previouslyTabbable.removeAttr("tabindex"), this._$previouslyWithTabIndex.each(function (t, n) {
                        e(n).attr("tabindex", r._previousWithTabIndices[t]);
                    }), this._previouslyActive.focus(), 0 === t.opened().length && e(document.documentElement).removeClass("with-featherlight"), o;
                }, onResize: function onResize(e, t) {
                    return this.resize(this.$content.naturalWidth, this.$content.naturalHeight), e(t);
                }, afterContent: function afterContent(e, t) {
                    var n = e(t);return this.$instance.find("[autofocus]:not([disabled])").focus(), this.onResize(t), n;
                } } }), e.featherlight = t, e.fn.featherlight = function (e, n) {
            return t.attach(this, e, n), this;
        }, e(document).ready(function () {
            t._onReady();
        });
    }(jQuery);
};